// import api_master_data from "../../api/api_master_data";
import axios from 'axios'
import { getBaseURLforBackEnd  , getConfigAxios } from '@/utils.js'
import Fingerprint2 from "fingerprintjs2"


export default {
    namespaced: true,

    state: {
        counterTest:0,
        avartar: '',
        fingerPrint:'',
        pathologists: [],
        parasitologists: [],
        docKind: [],
        docKindAll: [],
        statusLabs : [],
        user_id : null,
        userName : null,
        userIsAdmin : null,
        user_full_name_surname: null,
        user_role :[],
        clientIP : '0.0.0.0',     // default
        userCustomizeCBCTbl :     // Object
                                    {
                                        "cus1": [],
                                        "cus2": [],
                                        "cus3": []
                                    },
        unitCBC :[],

        
        dataLabParamsMaster: [
            {
               "id":1,
               "label":"WBC",
               "label_1":"White blood cell count",
               "group":"HEMATOLOGY",
               "key":"hm_wbc",
               "isSwitchedCUS1":true,
               "isSwitchedCUS2":false,
               "isSwitchedCUS3":false,
               "isNumberic":true,
               "order":0,
               "uuid":"nqnzPGc87H"
            },
            {
               "id":2,
               "label":"NEUT %",
               "label_1":"Percent Neutrophil count",
               "group":"HEMATOLOGY",
               "key":"hm_segs",
               "isSwitchedCUS1":true,
               "isSwitchedCUS2":false,
               "isSwitchedCUS3":false,
               "isNumberic":true,
               "order":1,
               "uuid":"aHangQiSa3"
            },
            {
               "id":3,
               "label":"LYMPH %",
               "label_1":"Percent Lymphocyte count",
               "group":"HEMATOLOGY",
               "key":"hm_lymph",
               "isSwitchedCUS1":true,
               "isSwitchedCUS2":false,
               "isSwitchedCUS3":false,
               "isNumberic":true,
               "order":2,
               "uuid":"Y11OxBAivQ"
            },
            {
               "id":4,
               "label":"MONO %",
               "label_1":"Percent Monocyte count",
               "group":"HEMATOLOGY",
               "key":"hm_mono",
               "isSwitchedCUS1":true,
               "isSwitchedCUS2":false,
               "isSwitchedCUS3":false,
               "isNumberic":true,
               "order":3,
               "uuid":"IPdC0Wpmt7"
            },
            {
               "id":5,
               "label":"EO %",
               "label_1":"Percent Eosinophil count",
               "group":"HEMATOLOGY",
               "key":"hm_eos",
               "isSwitchedCUS1":true,
               "isSwitchedCUS2":false,
               "isSwitchedCUS3":false,
               "isNumberic":true,
               "order":4,
               "uuid":"zFKjBnOJDP"
            },
            {
               "id":6,
               "label":"BASO %",
               "label_1":"Percent Basophil count",
               "group":"HEMATOLOGY",
               "key":"hm_baso",
               "isSwitchedCUS1":true,
               "isSwitchedCUS2":false,
               "isSwitchedCUS3":false,
               "isNumberic":true,
               "order":5,
               "uuid":"tjryiD4N0t"
            },
            {
               "id":7,
               "label":"NEUT #",
               "label_1":"Number of Neutrophils",
               "group":"HEMATOLOGY",
               "key":"hm_neut",
               "isSwitchedCUS1":true,
               "isSwitchedCUS2":false,
               "isSwitchedCUS3":false,
               "isNumberic":true,
               "order":6,
               "uuid":"6gqszeBErI"
            },
            {
               "id":8,
               "label":"LYMPH # ",
               "label_1":"Number of Lymphocytes",
               "group":"HEMATOLOGY",
               "key":"hm_lymph1",
               "isSwitchedCUS1":false,
               "isSwitchedCUS2":false,
               "isSwitchedCUS3":false,
               "isNumberic":true,
               "order":7,
               "uuid":"yNc3fDTT2C"
            },
            {
               "id":9,
               "label":"MONO # ",
               "label_1":"Number of Lymphocytes",
               "group":"HEMATOLOGY",
               "key":"hm_mono1",
               "isSwitchedCUS1":false,
               "isSwitchedCUS2":false,
               "isSwitchedCUS3":false,
               "isNumberic":true,
               "order":8,
               "uuid":"0wix7KNsjY"
            },
            {
               "id":10,
               "label":"EO #",
               "label_1":"Number of Eosinophils",
               "group":"HEMATOLOGY",
               "key":"hm_eo",
               "isSwitchedCUS1":false,
               "isSwitchedCUS2":false,
               "isSwitchedCUS3":false,
               "isNumberic":true,
               "order":9,
               "uuid":"PUWZojE6sI"
            },
            {
               "id":11,
               "label":"BASO # ",
               "label_1":"Number of Basophils",
               "group":"HEMATOLOGY",
               "key":"hm_baso1",
               "isSwitchedCUS1":false,
               "isSwitchedCUS2":false,
               "isSwitchedCUS3":false,
               "isNumberic":true,
               "order":10,
               "uuid":"i5qijrX4oI"
            },
            {
               "id":12,
               "label":"NRBC % ",
               "label_1":"Percent of nucleated red blood cells",
               "group":"HEMATOLOGY",
               "key":"hm_nucl_rbc",
               "isSwitchedCUS1":false,
               "isSwitchedCUS2":false,
               "isSwitchedCUS3":false,
               "isNumberic":true,
               "order":11,
               "uuid":"MQr2Jiwewk"
            },
            {
               "id":13,
               "label":"NRBC #",
               "label_1":"Number of nucleated red blood cells",
               "group":"HEMATOLOGY",
               "key":"hm_nrbc",
               "isSwitchedCUS1":false,
               "isSwitchedCUS2":false,
               "isSwitchedCUS3":false,
               "isNumberic":true,
               "order":12,
               "uuid":"gaL4Kf0svq"
            },
            {
               "id":14,
               "label":"MY CYTE",
               "label_1":"Myelocyte",
               "group":"HEMATOLOGY",
               "key":"hm_my_cyte",
               "isSwitchedCUS1":false,
               "isSwitchedCUS2":false,
               "isSwitchedCUS3":false,
               "isNumberic":true,
               "order":13,
               "uuid":"5xRoqdH4wi"
            },
            {
               "id":15,
               "label":"META",
               "label_1":"Metamyelocyte",
               "group":"HEMATOLOGY",
               "key":"hm_meta",
               "isSwitchedCUS1":false,
               "isSwitchedCUS2":false,
               "isSwitchedCUS3":false,
               "isNumberic":true,
               "order":14,
               "uuid":"gb8bupXIZ6"
            },
            {
               "id":16,
               "label":"Blast cell",
               "label_1":"Blast cell",
               "group":"HEMATOLOGY",
               "key":"hm_blascell",
               "isSwitchedCUS1":false,
               "isSwitchedCUS2":false,
               "isSwitchedCUS3":false,
               "isNumberic":true,
               "order":15,
               "uuid":"APxvN1IMZF"
            },
            {
               "id":17,
               "label":"Mast cell",
               "label_1":"Mast cell",
               "group":"HEMATOLOGY",
               "key":"hm_mastcell",
               "isSwitchedCUS1":false,
               "isSwitchedCUS2":false,
               "isSwitchedCUS3":false,
               "isNumberic":true,
               "order":16,
               "uuid":"PoogCU71Zh"
            },
            {
               "id":18,
               "label":"Band",
               "label_1":"Band neutrophil",
               "group":"HEMATOLOGY",
               "key":"hm_band",
               "isSwitchedCUS1":false,
               "isSwitchedCUS2":false,
               "isSwitchedCUS3":false,
               "isNumberic":true,
               "order":17,
               "uuid":"Rv1EvDTziv"
            },
            {
               "id":19,
               "label":"UNCLASS",
               "label_1":"Unclassified",
               "group":"HEMATOLOGY",
               "key":"hm_unclass",
               "isSwitchedCUS1":false,
               "isSwitchedCUS2":false,
               "isSwitchedCUS3":false,
               "isNumberic":true,
               "order":18,
               "uuid":"eyjRGiwThu"
            },
            {
               "id":20,
               "label":"RBC",
               "label_1":"Total number of erythrocytes",
               "group":"HEMATOLOGY",
               "key":"hm_rbc",
               "isSwitchedCUS1":false,
               "isSwitchedCUS2":false,
               "isSwitchedCUS3":false,
               "isNumberic":true,
               "order":19,
               "uuid":"YQANmOcCQF"
            },
            {
               "id":21,
               "label":"HGB",
               "label_1":"Hemoglobin concentration",
               "group":"HEMATOLOGY",
               "key":"hm_hgb",
               "isSwitchedCUS1":false,
               "isSwitchedCUS2":false,
               "isSwitchedCUS3":false,
               "isNumberic":true,
               "order":20,
               "uuid":"2bVmLHHG6d"
            },
            {
               "id":22,
               "label":"Hematocrit",
               "label_1":"Hematocrit value",
               "group":"HEMATOLOGY",
               "key":"hm_pcv",
               "isSwitchedCUS1":false,
               "isSwitchedCUS2":false,
               "isSwitchedCUS3":false,
               "isNumberic":true,
               "order":21,
               "uuid":"ee3hNGriZn"
            },
            {
               "id":23,
               "label":"PCV ปั่น",
               "label_1":"Packed cell volume",
               "group":"HEMATOLOGY",
               "key":"hm_pcv1",
               "isSwitchedCUS1":false,
               "isSwitchedCUS2":false,
               "isSwitchedCUS3":false,
               "isNumberic":true,
               "order":22,
               "uuid":"s37HoxVmtU"
            },
            {
               "id":24,
               "label":"MCV",
               "label_1":"Mean erythrocyte volume in total sample",
               "group":"HEMATOLOGY",
               "key":"hm_mcv",
               "isSwitchedCUS1":false,
               "isSwitchedCUS2":false,
               "isSwitchedCUS3":false,
               "isNumberic":true,
               "order":23,
               "uuid":"GWYlTfbWdo"
            },
            {
               "id":25,
               "label":"MCH",
               "label_1":"Mean hemoglobin volume per  RBC count",
               "group":"HEMATOLOGY",
               "key":"hm_mch",
               "isSwitchedCUS1":false,
               "isSwitchedCUS2":false,
               "isSwitchedCUS3":false,
               "isNumberic":true,
               "order":24,
               "uuid":"Wope9AicCZ"
            },
            {
               "id":26,
               "label":"MCHC",
               "label_1":"Mean hemoglobin concentration of erythrocytes",
               "group":"HEMATOLOGY",
               "key":"hm_mchc",
               "isSwitchedCUS1":false,
               "isSwitchedCUS2":false,
               "isSwitchedCUS3":false,
               "isNumberic":true,
               "order":25,
               "uuid":"Eb1TKTFQXy"
            },
            {
               "id":27,
               "label":"RDW-SD",
               "label_1":"Red Cell Distribution Width (standard deviation)",
               "group":"HEMATOLOGY",
               "key":"hm_rdw",
               "isSwitchedCUS1":false,
               "isSwitchedCUS2":false,
               "isSwitchedCUS3":false,
               "isNumberic":true,
               "order":26,
               "uuid":"c7IHeSwQ6I"
            },
            {
               "id":28,
               "label":"RDW-CV",
               "label_1":"Red Cell Distribution Width (coefficient of variation)",
               "group":"HEMATOLOGY",
               "key":"hm_rdwc",
               "isSwitchedCUS1":false,
               "isSwitchedCUS2":false,
               "isSwitchedCUS3":false,
               "isNumberic":true,
               "order":27,
               "uuid":"8iIm7fAhyX"
            },
            {
               "id":29,
               "label":"PLT - I",
               "label_1":"Platelet Impedant",
               "group":"HEMATOLOGY",
               "key":"hm_plti",
               "isSwitchedCUS1":false,
               "isSwitchedCUS2":false,
               "isSwitchedCUS3":false,
               "isNumberic":true,
               "order":28,
               "uuid":"Y0MbXkzRGl"
            },
            {
               "id":30,
               "label":"PLT - O",
               "label_1":"Platelet Optical",
               "group":"HEMATOLOGY",
               "key":"hm_plto",
               "isSwitchedCUS1":false,
               "isSwitchedCUS2":false,
               "isSwitchedCUS3":false,
               "isNumberic":true,
               "order":29,
               "uuid":"MpvY8N0vZb"
            },
            {
               "id":31,
               "label":"PLT - count",
               "label_1":"Platelet count",
               "group":"HEMATOLOGY",
               "key":"hm_platelets",
               "isSwitchedCUS1":false,
               "isSwitchedCUS2":false,
               "isSwitchedCUS3":false,
               "isNumberic":true,
               "order":30,
               "uuid":"bgAsYzobsQ"
            },
            {
               "id":32,
               "label":"MPV",
               "label_1":"Mean platelet volume",
               "group":"HEMATOLOGY",
               "key":"hm_mpv",
               "isSwitchedCUS1":false,
               "isSwitchedCUS2":false,
               "isSwitchedCUS3":false,
               "isNumberic":true,
               "order":31,
               "uuid":"mxd42x0zpW"
            },
            {
               "id":33,
               "label":"PDW",
               "label_1":"Platelet distribution width",
               "group":"HEMATOLOGY",
               "key":"hm_pdw",
               "isSwitchedCUS1":false,
               "isSwitchedCUS2":false,
               "isSwitchedCUS3":false,
               "isNumberic":true,
               "order":32,
               "uuid":"8yOWFzQ7lk"
            },
            {
               "id":34,
               "label":"P-LCR",
               "label_1":"Platelet-large cell ratio",
               "group":"HEMATOLOGY",
               "key":"hm_plcr",
               "isSwitchedCUS1":false,
               "isSwitchedCUS2":false,
               "isSwitchedCUS3":false,
               "isNumberic":true,
               "order":33,
               "uuid":"R5zVU17Goq"
            },
            {
               "id":35,
               "label":"PCT",
               "label_1":"Plateletcrit",
               "group":"HEMATOLOGY",
               "key":"hm_pct",
               "isSwitchedCUS1":false,
               "isSwitchedCUS2":false,
               "isSwitchedCUS3":false,
               "isNumberic":true,
               "order":34,
               "uuid":"w6MR8bPGUA"
            },
            {
               "id":36,
               "label":"RET%",
               "label_1":"Reticulocyte percent",
               "group":"HEMATOLOGY",
               "key":"hm_retics",
               "isSwitchedCUS1":false,
               "isSwitchedCUS2":false,
               "isSwitchedCUS3":false,
               "isNumberic":true,
               "order":35,
               "uuid":"LpO8sSdyjz"
            },
            {
               "id":37,
               "label":"RET#",
               "label_1":"Reticulocyte count",
               "group":"HEMATOLOGY",
               "key":"hm_ret1",
               "isSwitchedCUS1":false,
               "isSwitchedCUS2":false,
               "isSwitchedCUS3":false,
               "isNumberic":true,
               "order":36,
               "uuid":"p9PKhAjG7o"
            },
            {
               "id":38,
               "label":"IRF",
               "label_1":"Immature reticulocyte fraction",
               "group":"HEMATOLOGY",
               "key":"hm_irf",
               "isSwitchedCUS1":false,
               "isSwitchedCUS2":false,
               "isSwitchedCUS3":false,
               "isNumberic":true,
               "order":37,
               "uuid":"6hkpFW22EI"
            },
            {
               "id":39,
               "label":"LFR",
               "label_1":"Low fluorescence ratio",
               "group":"HEMATOLOGY",
               "key":"hm_lfr",
               "isSwitchedCUS1":false,
               "isSwitchedCUS2":false,
               "isSwitchedCUS3":false,
               "isNumberic":true,
               "order":38,
               "uuid":"KyH4aYDDNi"
            },
            {
               "id":40,
               "label":"HFR",
               "label_1":"High fluorescence ratio",
               "group":"HEMATOLOGY",
               "key":"hm_hfr",
               "isSwitchedCUS1":false,
               "isSwitchedCUS2":false,
               "isSwitchedCUS3":false,
               "isNumberic":true,
               "order":39,
               "uuid":"qeWgN7wo4i"
            },
            {
               "id":41,
               "label":"RET-He",
               "label_1":"Reticulocyte hemoglobin equivalent",
               "group":"HEMATOLOGY",
               "key":"hm_ret_he",
               "isSwitchedCUS1":false,
               "isSwitchedCUS2":false,
               "isSwitchedCUS3":false,
               "isNumberic":true,
               "order":40,
               "uuid":"wjjS1mDPAf"
            },
            {
               "id":42,
               "label":"RPI",
               "label_1":"Reticulocyte Production Index",
               "group":"HEMATOLOGY",
               "key":"hm_rpi",
               "isSwitchedCUS1":false,
               "isSwitchedCUS2":false,
               "isSwitchedCUS3":false,
               "isNumberic":true,
               "order":41,
               "uuid":"aTQXRAeGYm"
            },
            {
               "id":43,
               "label":"PP",
               "label_1":"Plasma proteins",
               "group":"HEMATOLOGY",
               "key":"hm_protein_refract ",
               "isSwitchedCUS1":false,
               "isSwitchedCUS2":false,
               "isSwitchedCUS3":false,
               "isNumberic":true,
               "order":42,
               "uuid":"PDcydLuzSy"
            },
            {
               "id":44,
               "label":"WBC-BF",
               "label_1":"White blood cell (leukocyte) count",
               "group":"BODY_FLUID",
               "key":"bf_wbcbf",
               "isSwitchedCUS1":false,
               "isSwitchedCUS2":false,
               "isSwitchedCUS3":false,
               "isNumberic":true,
               "order":43,
               "uuid":"GO8CkdbS2I"
            },
            {
               "id":45,
               "label":"RBC-BF",
               "label_1":"Red blood cell (erythrocyte) count",
               "group":"BODY_FLUID",
               "key":"bf_rbcbf",
               "isSwitchedCUS1":false,
               "isSwitchedCUS2":false,
               "isSwitchedCUS3":false,
               "isNumberic":true,
               "order":44,
               "uuid":"V57kXwiqBH"
            },
            {
               "id":46,
               "label":"MN#",
               "label_1":"Mononuclear count",
               "group":"BODY_FLUID",
               "key":"BF_MN",
               "isSwitchedCUS1":false,
               "isSwitchedCUS2":false,
               "isSwitchedCUS3":false,
               "isNumberic":true,
               "order":45,
               "uuid":"mMzVAliZFJ"
            },
            {
               "id":47,
               "label":"PMN#",
               "label_1":"Polymorphonuclear count",
               "group":"BODY_FLUID",
               "key":"bf_pmn",
               "isSwitchedCUS1":false,
               "isSwitchedCUS2":false,
               "isSwitchedCUS3":false,
               "isNumberic":true,
               "order":46,
               "uuid":"1Rs8oDNteW"
            },
            {
               "id":48,
               "label":"MN%",
               "label_1":"Mononuclear percent",
               "group":"BODY_FLUID",
               "key":"bf_mn1",
               "isSwitchedCUS1":false,
               "isSwitchedCUS2":false,
               "isSwitchedCUS3":false,
               "isNumberic":true,
               "order":47,
               "uuid":"TNti4iGOXX"
            },
            {
               "id":49,
               "label":"PMN%",
               "label_1":"Polymorphonuclear percent",
               "group":"BODY_FLUID",
               "key":"bf_pmn1",
               "isSwitchedCUS1":false,
               "isSwitchedCUS2":false,
               "isSwitchedCUS3":false,
               "isNumberic":true,
               "order":48,
               "uuid":"Kef2cOB3JX"
            },
            {
               "id":50,
               "label":"TC-BF",
               "label_1":"Total nucleated cell count",
               "group":"BODY_FLUID",
               "key":"BF_TCBF",
               "isSwitchedCUS1":false,
               "isSwitchedCUS2":false,
               "isSwitchedCUS3":false,
               "isNumberic":true,
               "order":49,
               "uuid":"udWheqFNP0"
            },
            {
               "id":51,
               "label":"BUN",
               "label_1":"Blood urea nitrogen",
               "group":"BLOOD_CHEMISTRY",
               "key":"bc_bun",
               "isSwitchedCUS1":false,
               "isSwitchedCUS2":false,
               "isSwitchedCUS3":false,
               "isNumberic":true,
               "order":50,
               "uuid":"dVX4afxrTV"
            },
            {
               "id":52,
               "label":"CREA",
               "label_1":"Creatinine",
               "group":"BLOOD_CHEMISTRY",
               "key":"bc_creatinine",
               "isSwitchedCUS1":false,
               "isSwitchedCUS2":false,
               "isSwitchedCUS3":false,
               "isNumberic":true,
               "order":51,
               "uuid":"p8jzPa2c4L"
            },
            {
               "id":53,
               "label":"URIC",
               "label_1":"Uric acid",
               "group":"BLOOD_CHEMISTRY",
               "key":"bc_uric",
               "isSwitchedCUS1":false,
               "isSwitchedCUS2":false,
               "isSwitchedCUS3":false,
               "isNumberic":true,
               "order":52,
               "uuid":"EXxdDcodH9"
            },
            {
               "id":54,
               "label":"CHOL",
               "label_1":"Cholesterol",
               "group":"BLOOD_CHEMISTRY",
               "key":"bc_cholesterol",
               "isSwitchedCUS1":false,
               "isSwitchedCUS2":false,
               "isSwitchedCUS3":false,
               "isNumberic":true,
               "order":53,
               "uuid":"3rwMpp9PfW"
            },
            {
               "id":55,
               "label":"TRIG",
               "label_1":"Triglycerides",
               "group":"BLOOD_CHEMISTRY",
               "key":"bc_triglyceride",
               "isSwitchedCUS1":false,
               "isSwitchedCUS2":false,
               "isSwitchedCUS3":false,
               "isNumberic":true,
               "order":54,
               "uuid":"S1c0UCkleK"
            },
            {
               "id":56,
               "label":"TP",
               "label_1":"Total protein",
               "group":"BLOOD_CHEMISTRY",
               "key":"bc_protein_biuret",
               "isSwitchedCUS1":false,
               "isSwitchedCUS2":false,
               "isSwitchedCUS3":false,
               "isNumberic":true,
               "order":55,
               "uuid":"JNH1DWPgQf"
            },
            {
               "id":57,
               "label":"ALB",
               "label_1":"Albumin",
               "group":"BLOOD_CHEMISTRY",
               "key":"bc_albumin",
               "isSwitchedCUS1":false,
               "isSwitchedCUS2":false,
               "isSwitchedCUS3":false,
               "isNumberic":true,
               "order":56,
               "uuid":"qupQI6jQgY"
            },
            {
               "id":58,
               "label":"Glob",
               "label_1":"Globulin",
               "group":"BLOOD_CHEMISTRY",
               "key":"bc_glob",
               "isSwitchedCUS1":false,
               "isSwitchedCUS2":false,
               "isSwitchedCUS3":false,
               "isNumberic":true,
               "order":57,
               "uuid":"WMlTIXYuhS"
            },
            {
               "id":59,
               "label":"TBIL",
               "label_1":"Total bilirubin",
               "group":"BLOOD_CHEMISTRY",
               "key":"bc_bilirubin_total",
               "isSwitchedCUS1":false,
               "isSwitchedCUS2":false,
               "isSwitchedCUS3":false,
               "isNumberic":true,
               "order":58,
               "uuid":"NPRn8UY0Pp"
            },
            {
               "id":60,
               "label":"DBIL",
               "label_1":"Direct Bilirubin",
               "group":"BLOOD_CHEMISTRY",
               "key":"bc_direct",
               "isSwitchedCUS1":false,
               "isSwitchedCUS2":false,
               "isSwitchedCUS3":false,
               "isNumberic":true,
               "order":59,
               "uuid":"agkr5dO3od"
            },
            {
               "id":61,
               "label":"AST",
               "label_1":"Aspartate aminotransferase",
               "group":"BLOOD_CHEMISTRY",
               "key":"bc_ast_sgot",
               "isSwitchedCUS1":false,
               "isSwitchedCUS2":false,
               "isSwitchedCUS3":false,
               "isNumberic":true,
               "order":60,
               "uuid":"fLSuhM9Upp"
            },
            {
               "id":62,
               "label":"ALT",
               "label_1":"Alanine aminotransferase",
               "group":"BLOOD_CHEMISTRY",
               "key":"bc_alt_sgpt",
               "isSwitchedCUS1":false,
               "isSwitchedCUS2":false,
               "isSwitchedCUS3":false,
               "isNumberic":true,
               "order":61,
               "uuid":"UAEAvlBxWD"
            },
            {
               "id":63,
               "label":"ALP",
               "label_1":"Alkaline phosphatase",
               "group":"BLOOD_CHEMISTRY",
               "key":"bc_alk_phos",
               "isSwitchedCUS1":false,
               "isSwitchedCUS2":false,
               "isSwitchedCUS3":false,
               "isNumberic":true,
               "order":62,
               "uuid":"4fURykBnfG"
            },
            {
               "id":64,
               "label":"CSF",
               "label_1":"Cerebrospinal Fluid Protein",
               "group":"BLOOD_CHEMISTRY",
               "key":"bc_csf",
               "isSwitchedCUS1":false,
               "isSwitchedCUS2":false,
               "isSwitchedCUS3":false,
               "isNumberic":true,
               "order":63,
               "uuid":"l8adZuKBjf"
            },
            {
               "id":65,
               "label":"GGT",
               "label_1":"Gamma-glutaamyltransferase",
               "group":"BLOOD_CHEMISTRY",
               "key":"bc_ggt",
               "isSwitchedCUS1":false,
               "isSwitchedCUS2":false,
               "isSwitchedCUS3":false,
               "isNumberic":true,
               "order":64,
               "uuid":"JC2OEU6DZw"
            },
            {
               "id":66,
               "label":"Ca",
               "label_1":"Calcium",
               "group":"BLOOD_CHEMISTRY",
               "key":"bc_calcium",
               "isSwitchedCUS1":false,
               "isSwitchedCUS2":false,
               "isSwitchedCUS3":false,
               "isNumberic":true,
               "order":65,
               "uuid":"YCv4A12nGO"
            },
            {
               "id":67,
               "label":"PHOS",
               "label_1":"Inorganic phosphorus",
               "group":"BLOOD_CHEMISTRY",
               "key":"bc_phosphorus",
               "isSwitchedCUS1":false,
               "isSwitchedCUS2":false,
               "isSwitchedCUS3":false,
               "isNumberic":true,
               "order":66,
               "uuid":"K9mlR05Bm9"
            },
            {
               "id":68,
               "label":"Sodium",
               "label_1":"Sodium",
               "group":"BLOOD_CHEMISTRY",
               "key":"bc_sodium",
               "isSwitchedCUS1":false,
               "isSwitchedCUS2":false,
               "isSwitchedCUS3":false,
               "isNumberic":true,
               "order":67,
               "uuid":"FBTnSiCT9W"
            },
            {
               "id":69,
               "label":"Potassium",
               "label_1":"Potassium",
               "group":"BLOOD_CHEMISTRY",
               "key":"bc_potassium",
               "isSwitchedCUS1":false,
               "isSwitchedCUS2":false,
               "isSwitchedCUS3":false,
               "isNumberic":true,
               "order":68,
               "uuid":"2Cwxoq8us4"
            },
            {
               "id":70,
               "label":"Chloride",
               "label_1":"Chloride",
               "group":"BLOOD_CHEMISTRY",
               "key":"bc_chloride",
               "isSwitchedCUS1":false,
               "isSwitchedCUS2":false,
               "isSwitchedCUS3":false,
               "isNumberic":true,
               "order":69,
               "uuid":"kZu8iAvQ44"
            },
            {
               "id":71,
               "label":"CK",
               "label_1":"Creatinine kinase",
               "group":"BLOOD_CHEMISTRY",
               "key":"bc_cpk",
               "isSwitchedCUS1":false,
               "isSwitchedCUS2":false,
               "isSwitchedCUS3":false,
               "isNumberic":true,
               "order":70,
               "uuid":"BUC2WvUbMk"
            },
            {
               "id":72,
               "label":"NH3",
               "label_1":"Ammonia",
               "group":"BLOOD_CHEMISTRY",
               "key":"bc_ammonia",
               "isSwitchedCUS1":false,
               "isSwitchedCUS2":false,
               "isSwitchedCUS3":false,
               "isNumberic":true,
               "order":71,
               "uuid":"KMUCU6OSwl"
            },
            {
               "id":73,
               "label":"GLU",
               "label_1":"Glucose",
               "group":"BLOOD_CHEMISTRY",
               "key":"bc_glucose",
               "isSwitchedCUS1":false,
               "isSwitchedCUS2":false,
               "isSwitchedCUS3":false,
               "isNumberic":true,
               "order":72,
               "uuid":"BfT3yETuX4"
            },
            {
               "id":74,
               "label":"UCRE",
               "label_1":"Urine creatinine",
               "group":"BLOOD_CHEMISTRY",
               "key":"ur_creatinine",
               "isSwitchedCUS1":false,
               "isSwitchedCUS2":false,
               "isSwitchedCUS3":false,
               "isNumberic":true,
               "order":73,
               "uuid":"C7XTALzDWU"
            },
            {
               "id":75,
               "label":"UPRO",
               "label_1":"Urine protein",
               "group":"BLOOD_CHEMISTRY",
               "key":"bc_upro",
               "isSwitchedCUS1":false,
               "isSwitchedCUS2":false,
               "isSwitchedCUS3":false,
               "isNumberic":true,
               "order":74,
               "uuid":"QiC1J1KdTd"
            },
            {
               "id":76,
               "label":"AMYL",
               "label_1":"Amylase",
               "group":"BLOOD_CHEMISTRY",
               "key":"bc_amylase",
               "isSwitchedCUS1":false,
               "isSwitchedCUS2":false,
               "isSwitchedCUS3":false,
               "isNumberic":true,
               "order":75,
               "uuid":"mJGcHrxB9v"
            },
            {
               "id":77,
               "label":"CRP",
               "label_1":"C-reactive protein",
               "group":"BLOOD_CHEMISTRY",
               "key":"bc_crp",
               "isSwitchedCUS1":false,
               "isSwitchedCUS2":false,
               "isSwitchedCUS3":false,
               "isNumberic":true,
               "order":76,
               "uuid":"9KI33R6qwm"
            },
            {
               "id":78,
               "label":"SDMA",
               "label_1":"Symmetric dimethylarginine",
               "group":"BLOOD_CHEMISTRY",
               "key":"bc_sdma",
               "isSwitchedCUS1":false,
               "isSwitchedCUS2":false,
               "isSwitchedCUS3":false,
               "isNumberic":true,
               "order":77,
               "uuid":"IgKJOmQerL"
            },
            {
               "id":79,
               "label":"TT4(T4)",
               "label_1":"Total Thyroxine",
               "group":"BLOOD_CHEMISTRY",
               "key":"bc_tt4",
               "isSwitchedCUS1":false,
               "isSwitchedCUS2":false,
               "isSwitchedCUS3":false,
               "isNumberic":true,
               "order":78,
               "uuid":"EIpTpV0h1a"
            },
            {
               "id":80,
               "label":"FRU",
               "label_1":"Fructosamine",
               "group":"BLOOD_CHEMISTRY",
               "key":"sp_fructo",
               "isSwitchedCUS1":false,
               "isSwitchedCUS2":false,
               "isSwitchedCUS3":false,
               "isNumberic":true,
               "order":79,
               "uuid":"EIIpSNWtrJ"
            },
            {
               "id":81,
               "label":"LAC",
               "label_1":"Lactate",
               "group":"BLOOD_CHEMISTRY",
               "key":"bc_fru",
               "isSwitchedCUS1":false,
               "isSwitchedCUS2":false,
               "isSwitchedCUS3":false,
               "isNumberic":true,
               "order":80,
               "uuid":"xwX1LezMsw"
            },
            {
               "id":82,
               "label":"LDH",
               "label_1":"Lactate dehydrogenase",
               "group":"BLOOD_CHEMISTRY",
               "key":"bc_lac",
               "isSwitchedCUS1":false,
               "isSwitchedCUS2":false,
               "isSwitchedCUS3":false,
               "isNumberic":true,
               "order":81,
               "uuid":"hYDgO64MnK"
            },
            {
               "id":83,
               "label":"LIPA",
               "label_1":"Lipase",
               "group":"BLOOD_CHEMISTRY",
               "key":"sp_lipase",
               "isSwitchedCUS1":false,
               "isSwitchedCUS2":false,
               "isSwitchedCUS3":false,
               "isNumberic":true,
               "order":82,
               "uuid":"tWbsys6wkD"
            },
            {
               "id":84,
               "label":"Mg",
               "label_1":"Magnesium",
               "group":"BLOOD_CHEMISTRY",
               "key":"bc_mg",
               "isSwitchedCUS1":false,
               "isSwitchedCUS2":false,
               "isSwitchedCUS3":false,
               "isNumberic":true,
               "order":83,
               "uuid":"VbgL2oltE1"
            },
            {
               "id":85,
               "label":"PROG",
               "label_1":"Progesterone",
               "group":"BLOOD_CHEMISTRY",
               "key":"bc_prog",
               "isSwitchedCUS1":false,
               "isSwitchedCUS2":false,
               "isSwitchedCUS3":false,
               "isNumberic":true,
               "order":84,
               "uuid":"4SvGhUp3gA"
            },
            {
               "id":86,
               "label":"BA",
               "label_1":"Bile acids",
               "group":"BLOOD_CHEMISTRY",
               "key":"bc_bileacid_fasting",
               "isSwitchedCUS1":false,
               "isSwitchedCUS2":false,
               "isSwitchedCUS3":false,
               "isNumberic":true,
               "order":85,
               "uuid":"KGUIypwnO5"
            },
            {
               "id":87,
               "label":"cT4",
               "label_1":"Canine thyroxine",
               "group":"HORMONE",
               "key":"hom_t4",
               "isSwitchedCUS1":false,
               "isSwitchedCUS2":false,
               "isSwitchedCUS3":false,
               "isNumberic":true,
               "order":86,
               "uuid":"ozJMrWEriF"
            },
            {
               "id":88,
               "label":"cTSH",
               "label_1":"Canine thyroid stimulating hormone",
               "group":"HORMONE",
               "key":"hom_ctsh",
               "isSwitchedCUS1":false,
               "isSwitchedCUS2":false,
               "isSwitchedCUS3":false,
               "isNumberic":true,
               "order":87,
               "uuid":"uq9X9YbIsQ"
            },
            {
               "id":89,
               "label":"cTLI",
               "label_1":"Canine trypsin-like immunoreactivity",
               "group":"HORMONE",
               "key":"hom_ctli",
               "isSwitchedCUS1":false,
               "isSwitchedCUS2":false,
               "isSwitchedCUS3":false,
               "isNumberic":true,
               "order":88,
               "uuid":"6id5Qw2ayT"
            },
            {
               "id":90,
               "label":"PHBR",
               "label_1":"Phenobarbitol",
               "group":"HORMONE",
               "key":"sp_phenobarb",
               "isSwitchedCUS1":false,
               "isSwitchedCUS2":false,
               "isSwitchedCUS3":false,
               "isNumberic":true,
               "order":89,
               "uuid":"YxSNfofRNc"
            },
            {
               "id":91,
               "label":"Cortisol",
               "label_1":"Cortisol",
               "group":"HORMONE",
               "key":"hom_cotis",
               "isSwitchedCUS1":false,
               "isSwitchedCUS2":false,
               "isSwitchedCUS3":false,
               "isNumberic":true,
               "order":90,
               "uuid":"CdHCOj9Ewk"
            },
            {
               "id":92,
               "label":"pH",
               "label_1":"",
               "group":"BLOOD_GAS",
               "key":"bg_ph",
               "isSwitchedCUS1":false,
               "isSwitchedCUS2":false,
               "isSwitchedCUS3":false,
               "isNumberic":true,
               "order":91,
               "uuid":"AJc5YSB4SU"
            },
            {
               "id":93,
               "label":"pCO2",
               "label_1":"",
               "group":"BLOOD_GAS",
               "key":"bg_pco2",
               "isSwitchedCUS1":false,
               "isSwitchedCUS2":false,
               "isSwitchedCUS3":false,
               "isNumberic":true,
               "order":92,
               "uuid":"4enZ4uSE7A"
            },
            {
               "id":94,
               "label":"pO2",
               "label_1":"",
               "group":"BLOOD_GAS",
               "key":"bg_po2",
               "isSwitchedCUS1":false,
               "isSwitchedCUS2":false,
               "isSwitchedCUS3":false,
               "isNumberic":true,
               "order":93,
               "uuid":"hfUgtlHMqf"
            },
            {
               "id":95,
               "label":"Na",
               "label_1":"",
               "group":"BLOOD_GAS",
               "key":"bg_na",
               "isSwitchedCUS1":false,
               "isSwitchedCUS2":false,
               "isSwitchedCUS3":false,
               "isNumberic":true,
               "order":94,
               "uuid":"pPEZQsMIRT"
            },
            {
               "id":96,
               "label":"K",
               "label_1":"",
               "group":"BLOOD_GAS",
               "key":"bg_k",
               "isSwitchedCUS1":false,
               "isSwitchedCUS2":false,
               "isSwitchedCUS3":false,
               "isNumberic":true,
               "order":95,
               "uuid":"3WMrI85nbD"
            },
            {
               "id":97,
               "label":"Cl",
               "label_1":"",
               "group":"BLOOD_GAS",
               "key":"bg_ci",
               "isSwitchedCUS1":false,
               "isSwitchedCUS2":false,
               "isSwitchedCUS3":false,
               "isNumberic":true,
               "order":96,
               "uuid":"QJaEI2wjgp"
            },
            {
               "id":98,
               "label":"iCa",
               "label_1":"",
               "group":"BLOOD_GAS",
               "key":"bg_ca",
               "isSwitchedCUS1":false,
               "isSwitchedCUS2":false,
               "isSwitchedCUS3":false,
               "isNumberic":true,
               "order":97,
               "uuid":"GfjCi7AVtc"
            },
            {
               "id":99,
               "label":"Hb",
               "label_1":"",
               "group":"BLOOD_GAS",
               "key":"bg_hb",
               "isSwitchedCUS1":false,
               "isSwitchedCUS2":false,
               "isSwitchedCUS3":false,
               "isNumberic":true,
               "order":98,
               "uuid":"ynQWCcLT8R"
            },
            {
               "id":100,
               "label":"HCT",
               "label_1":"",
               "group":"BLOOD_GAS",
               "key":"bg_hct",
               "isSwitchedCUS1":false,
               "isSwitchedCUS2":false,
               "isSwitchedCUS3":false,
               "isNumberic":true,
               "order":99,
               "uuid":"L5rwFUAgJc"
            },
            {
               "id":101,
               "label":"HCO3-act",
               "label_1":"",
               "group":"BLOOD_GAS",
               "key":"bg_hco3",
               "isSwitchedCUS1":false,
               "isSwitchedCUS2":false,
               "isSwitchedCUS3":false,
               "isNumberic":true,
               "order":100,
               "uuid":"Qe3tWeGggy"
            },
            {
               "id":102,
               "label":"BE(B)",
               "label_1":"",
               "group":"BLOOD_GAS",
               "key":"bg_be",
               "isSwitchedCUS1":false,
               "isSwitchedCUS2":false,
               "isSwitchedCUS3":false,
               "isNumberic":true,
               "order":101,
               "uuid":"P2rIFAm5vX"
            },
            {
               "id":103,
               "label":"ctCO2(P)",
               "label_1":"",
               "group":"BLOOD_GAS",
               "key":"bg_ctco2",
               "isSwitchedCUS1":false,
               "isSwitchedCUS2":false,
               "isSwitchedCUS3":false,
               "isNumberic":true,
               "order":102,
               "uuid":"TBXm0hClNp"
            },
            {
               "id":104,
               "label":"pH(T)",
               "label_1":"",
               "group":"BLOOD_GAS",
               "key":"bg_pht",
               "isSwitchedCUS1":false,
               "isSwitchedCUS2":false,
               "isSwitchedCUS3":false,
               "isNumberic":true,
               "order":103,
               "uuid":"4mM1Ft8lla"
            },
            {
               "id":105,
               "label":"pCO2(T)",
               "label_1":"",
               "group":"BLOOD_GAS",
               "key":"bg_pco2t",
               "isSwitchedCUS1":false,
               "isSwitchedCUS2":false,
               "isSwitchedCUS3":false,
               "isNumberic":true,
               "order":104,
               "uuid":"FlmYS2AhpU"
            },
            {
               "id":106,
               "label":"pO2(T)",
               "label_1":"",
               "group":"BLOOD_GAS",
               "key":"bg_po2t",
               "isSwitchedCUS1":false,
               "isSwitchedCUS2":false,
               "isSwitchedCUS3":false,
               "isNumberic":true,
               "order":105,
               "uuid":"sFlAnQw8vL"
            },
            {
               "id":107,
               "label":"sO2(est)",
               "label_1":"",
               "group":"BLOOD_GAS",
               "key":"bg_so2est",
               "isSwitchedCUS1":false,
               "isSwitchedCUS2":false,
               "isSwitchedCUS3":false,
               "isNumberic":true,
               "order":106,
               "uuid":"5ZbYuUg0d6"
            },
            {
               "id":108,
               "label":"iCa(7.4)",
               "label_1":"",
               "group":"BLOOD_GAS",
               "key":"bg_ica",
               "isSwitchedCUS1":false,
               "isSwitchedCUS2":false,
               "isSwitchedCUS3":false,
               "isNumberic":true,
               "order":107,
               "uuid":"uvmKcQtpDT"
            },
            {
               "id":109,
               "label":"Glc",
               "label_1":"",
               "group":"BLOOD_GAS",
               "key":"bg_glc",
               "isSwitchedCUS1":false,
               "isSwitchedCUS2":false,
               "isSwitchedCUS3":false,
               "isNumberic":true,
               "order":108,
               "uuid":"1lQs3Soura"
            },
            {
               "id":110,
               "label":"Lac",
               "label_1":"",
               "group":"BLOOD_GAS",
               "key":"bg_lac",
               "isSwitchedCUS1":false,
               "isSwitchedCUS2":false,
               "isSwitchedCUS3":false,
               "isNumberic":true,
               "order":109,
               "uuid":"38qwwIjazU"
            },
            {
               "id":111,
               "label":"Temperature",
               "label_1":"",
               "group":"BLOOD_GAS",
               "key":"bg_temp",
               "isSwitchedCUS1":false,
               "isSwitchedCUS2":false,
               "isSwitchedCUS3":false,
               "isNumberic":true,
               "order":110,
               "uuid":"61kxFxEWLs"
            },
            {
               "id":112,
               "label":"FIO2",
               "label_1":"",
               "group":"BLOOD_GAS",
               "key":"bg_fio2",
               "isSwitchedCUS1":false,
               "isSwitchedCUS2":false,
               "isSwitchedCUS3":false,
               "isNumberic":true,
               "order":111,
               "uuid":"dNLEvsPruL"
            },
            {
               "id":113,
               "label":"BP",
               "label_1":"",
               "group":"BLOOD_GAS",
               "key":"bg_bp",
               "isSwitchedCUS1":false,
               "isSwitchedCUS2":false,
               "isSwitchedCUS3":false,
               "isNumberic":true,
               "order":112,
               "uuid":"G4W8zHUa5s"
            },
            {
               "id":114,
               "label":"HCO3-std",
               "label_1":"",
               "group":"BLOOD_GAS",
               "key":"bg_hco3std",
               "isSwitchedCUS1":false,
               "isSwitchedCUS2":false,
               "isSwitchedCUS3":false,
               "isNumberic":true,
               "order":113,
               "uuid":"5WdzbEnXZR"
            },
            {
               "id":115,
               "label":"BE(ecf)",
               "label_1":"",
               "group":"BLOOD_GAS",
               "key":"bg_beecf",
               "isSwitchedCUS1":false,
               "isSwitchedCUS2":false,
               "isSwitchedCUS3":false,
               "isNumberic":true,
               "order":114,
               "uuid":"dncNaxeLFM"
            },
            {
               "id":116,
               "label":"cNa+",
               "label_1":"",
               "group":"BLOOD_GAS",
               "key":"bg_cna",
               "isSwitchedCUS1":false,
               "isSwitchedCUS2":false,
               "isSwitchedCUS3":false,
               "isNumberic":true,
               "order":115,
               "uuid":"PwOk2r3V1q"
            },
            {
               "id":117,
               "label":"cK+",
               "label_1":"",
               "group":"BLOOD_GAS",
               "key":"bg_ck",
               "isSwitchedCUS1":false,
               "isSwitchedCUS2":false,
               "isSwitchedCUS3":false,
               "isNumberic":true,
               "order":116,
               "uuid":"esVZQEnTQJ"
            },
            {
               "id":118,
               "label":"cCa2+",
               "label_1":"",
               "group":"BLOOD_GAS",
               "key":"bg_cca2",
               "isSwitchedCUS1":false,
               "isSwitchedCUS2":false,
               "isSwitchedCUS3":false,
               "isNumberic":true,
               "order":117,
               "uuid":"OiTedGTw6b"
            },
            {
               "id":119,
               "label":"cCI-",
               "label_1":"",
               "group":"BLOOD_GAS",
               "key":"bg_cci",
               "isSwitchedCUS1":false,
               "isSwitchedCUS2":false,
               "isSwitchedCUS3":false,
               "isNumberic":true,
               "order":118,
               "uuid":"bQ7wf6YMma"
            },
            {
               "id":120,
               "label":"cGlc",
               "label_1":"",
               "group":"BLOOD_GAS",
               "key":"bg_cglc",
               "isSwitchedCUS1":false,
               "isSwitchedCUS2":false,
               "isSwitchedCUS3":false,
               "isNumberic":true,
               "order":119,
               "uuid":"5Up5CsJVa4"
            },
            {
               "id":121,
               "label":"cLac",
               "label_1":"",
               "group":"BLOOD_GAS",
               "key":"bg_clac",
               "isSwitchedCUS1":false,
               "isSwitchedCUS2":false,
               "isSwitchedCUS3":false,
               "isNumberic":true,
               "order":120,
               "uuid":"SVC66yqa0v"
            },
            {
               "id":122,
               "label":"ctBil",
               "label_1":"",
               "group":"BLOOD_GAS",
               "key":"bg_ctbil",
               "isSwitchedCUS1":false,
               "isSwitchedCUS2":false,
               "isSwitchedCUS3":false,
               "isNumberic":true,
               "order":121,
               "uuid":"FL1ZZrrtCb"
            },
            {
               "id":123,
               "label":"ctHb",
               "label_1":"",
               "group":"BLOOD_GAS",
               "key":"bg_cthb",
               "isSwitchedCUS1":false,
               "isSwitchedCUS2":false,
               "isSwitchedCUS3":false,
               "isNumberic":true,
               "order":122,
               "uuid":"nP5VPdMpLE"
            },
            {
               "id":124,
               "label":"FHHb",
               "label_1":"",
               "group":"BLOOD_GAS",
               "key":"bg_fhhb",
               "isSwitchedCUS1":false,
               "isSwitchedCUS2":false,
               "isSwitchedCUS3":false,
               "isNumberic":true,
               "order":123,
               "uuid":"FpqVsDNplg"
            },
            {
               "id":125,
               "label":"FO2Hb",
               "label_1":"",
               "group":"BLOOD_GAS",
               "key":"bg_fo2hb",
               "isSwitchedCUS1":false,
               "isSwitchedCUS2":false,
               "isSwitchedCUS3":false,
               "isNumberic":true,
               "order":124,
               "uuid":"NokKBF8ysN"
            },
            {
               "id":126,
               "label":"FCOHb",
               "label_1":"",
               "group":"BLOOD_GAS",
               "key":"bg_fcohb",
               "isSwitchedCUS1":false,
               "isSwitchedCUS2":false,
               "isSwitchedCUS3":false,
               "isNumberic":true,
               "order":125,
               "uuid":"dNYqR02VbT"
            },
            {
               "id":127,
               "label":"FMetHb",
               "label_1":"",
               "group":"BLOOD_GAS",
               "key":"bg_fmethb",
               "isSwitchedCUS1":false,
               "isSwitchedCUS2":false,
               "isSwitchedCUS3":false,
               "isNumberic":true,
               "order":126,
               "uuid":"lnxcX9EjJL"
            },
            {
               "id":128,
               "label":"sO2",
               "label_1":"",
               "group":"BLOOD_GAS",
               "key":"bg_so2",
               "isSwitchedCUS1":false,
               "isSwitchedCUS2":false,
               "isSwitchedCUS3":false,
               "isNumberic":true,
               "order":127,
               "uuid":"hFrzQrfboZ"
            },
            {
               "id":129,
               "label":"AG",
               "label_1":"",
               "group":"BLOOD_GAS",
               "key":"bg_ag",
               "isSwitchedCUS1":false,
               "isSwitchedCUS2":false,
               "isSwitchedCUS3":false,
               "isNumberic":true,
               "order":128,
               "uuid":"LIt4eg9r9s"
            },
            {
               "id":130,
               "label":"AG(K)",
               "label_1":"",
               "group":"BLOOD_GAS",
               "key":"bg_agk",
               "isSwitchedCUS1":false,
               "isSwitchedCUS2":false,
               "isSwitchedCUS3":false,
               "isNumberic":true,
               "order":129,
               "uuid":"QZT9xadWRQ"
            },
            {
               "id":131,
               "label":"cHCO3- act",
               "label_1":"",
               "group":"BLOOD_GAS",
               "key":"bg_chact",
               "isSwitchedCUS1":false,
               "isSwitchedCUS2":false,
               "isSwitchedCUS3":false,
               "isNumberic":true,
               "order":130,
               "uuid":"RN6hgSiK5A"
            },
            {
               "id":132,
               "label":"cHCO3- std",
               "label_1":"",
               "group":"BLOOD_GAS",
               "key":"bg_chstd",
               "isSwitchedCUS1":false,
               "isSwitchedCUS2":false,
               "isSwitchedCUS3":false,
               "isNumberic":true,
               "order":131,
               "uuid":"4DtkRrfs7Z"
            },
            {
               "id":133,
               "label":"cBE(ecf)",
               "label_1":"",
               "group":"BLOOD_GAS",
               "key":"bg_cbeecf",
               "isSwitchedCUS1":false,
               "isSwitchedCUS2":false,
               "isSwitchedCUS3":false,
               "isNumberic":true,
               "order":132,
               "uuid":"Rm4vIrg28y"
            },
            {
               "id":134,
               "label":"CBE(B)",
               "label_1":"",
               "group":"BLOOD_GAS",
               "key":"BG_CBEB",
               "isSwitchedCUS1":false,
               "isSwitchedCUS2":false,
               "isSwitchedCUS3":false,
               "isNumberic":true,
               "order":133,
               "uuid":"J3ESJ8D0xY"
            },
            {
               "id":135,
               "label":"cBB",
               "label_1":"",
               "group":"BLOOD_GAS",
               "key":"bg_cbb",
               "isSwitchedCUS1":false,
               "isSwitchedCUS2":false,
               "isSwitchedCUS3":false,
               "isNumberic":true,
               "order":134,
               "uuid":"TNBXdwYkfn"
            },
            {
               "id":136,
               "label":"ctCO2(B)",
               "label_1":"",
               "group":"BLOOD_GAS",
               "key":"bg_ctco2b",
               "isSwitchedCUS1":false,
               "isSwitchedCUS2":false,
               "isSwitchedCUS3":false,
               "isNumberic":true,
               "order":135,
               "uuid":"ICayfXXtwV"
            },
            {
               "id":137,
               "label":"BO2",
               "label_1":"",
               "group":"BLOOD_GAS",
               "key":"bg_bo2",
               "isSwitchedCUS1":false,
               "isSwitchedCUS2":false,
               "isSwitchedCUS3":false,
               "isNumberic":true,
               "order":136,
               "uuid":"l5RAZzCjfM"
            },
            {
               "id":138,
               "label":"p50",
               "label_1":"",
               "group":"BLOOD_GAS",
               "key":"bg_p50",
               "isSwitchedCUS1":false,
               "isSwitchedCUS2":false,
               "isSwitchedCUS3":false,
               "isNumberic":true,
               "order":137,
               "uuid":"WifpnfEm88"
            },
            {
               "id":139,
               "label":"p50(T)",
               "label_1":"",
               "group":"BLOOD_GAS",
               "key":"bg_p50t",
               "isSwitchedCUS1":false,
               "isSwitchedCUS2":false,
               "isSwitchedCUS3":false,
               "isNumberic":true,
               "order":138,
               "uuid":"DaLUlADl16"
            },
            {
               "id":140,
               "label":"p50(st)",
               "label_1":"",
               "group":"BLOOD_GAS",
               "key":"bg_p50st",
               "isSwitchedCUS1":false,
               "isSwitchedCUS2":false,
               "isSwitchedCUS3":false,
               "isNumberic":true,
               "order":139,
               "uuid":"E6OnXcfg3W"
            },
            {
               "id":141,
               "label":"pO2/FiO2",
               "label_1":"",
               "group":"BLOOD_GAS",
               "key":"bg_po2fio2",
               "isSwitchedCUS1":false,
               "isSwitchedCUS2":false,
               "isSwitchedCUS3":false,
               "isNumberic":true,
               "order":140,
               "uuid":"zuMenA33j9"
            },
            {
               "id":142,
               "label":"cCa2+ (7.4)",
               "label_1":"",
               "group":"BLOOD_GAS",
               "key":"bg_cca2p",
               "isSwitchedCUS1":false,
               "isSwitchedCUS2":false,
               "isSwitchedCUS3":false,
               "isNumberic":true,
               "order":141,
               "uuid":"bzpPCjiROY"
            },
            {
               "id":143,
               "label":"pO2(A)",
               "label_1":"",
               "group":"BLOOD_GAS",
               "key":"bg_po2a",
               "isSwitchedCUS1":false,
               "isSwitchedCUS2":false,
               "isSwitchedCUS3":false,
               "isNumberic":true,
               "order":142,
               "uuid":"yrBLnr1QD9"
            },
            {
               "id":144,
               "label":"pO2(A)(T)",
               "label_1":"",
               "group":"BLOOD_GAS",
               "key":"bg_po2at",
               "isSwitchedCUS1":false,
               "isSwitchedCUS2":false,
               "isSwitchedCUS3":false,
               "isNumberic":true,
               "order":143,
               "uuid":"nXbrsc7oma"
            },
            {
               "id":145,
               "label":"pO2(A-a)",
               "label_1":"",
               "group":"BLOOD_GAS",
               "key":"bg_po2aa",
               "isSwitchedCUS1":false,
               "isSwitchedCUS2":false,
               "isSwitchedCUS3":false,
               "isNumberic":true,
               "order":144,
               "uuid":"w5lquaoeNp"
            },
            {
               "id":146,
               "label":"pO2(A-a)(T)",
               "label_1":"",
               "group":"BLOOD_GAS",
               "key":"bg_po2aat",
               "isSwitchedCUS1":false,
               "isSwitchedCUS2":false,
               "isSwitchedCUS3":false,
               "isNumberic":true,
               "order":145,
               "uuid":"EpmMSLZS4a"
            },
            {
               "id":147,
               "label":"pO2(a/A)",
               "label_1":"",
               "group":"BLOOD_GAS",
               "key":"bg_po2aa1",
               "isSwitchedCUS1":false,
               "isSwitchedCUS2":false,
               "isSwitchedCUS3":false,
               "isNumberic":true,
               "order":146,
               "uuid":"kfswR0gjKh"
            },
            {
               "id":148,
               "label":"pO2(a/A)(T)",
               "label_1":"",
               "group":"BLOOD_GAS",
               "key":"bg_po2aat1",
               "isSwitchedCUS1":false,
               "isSwitchedCUS2":false,
               "isSwitchedCUS3":false,
               "isNumberic":true,
               "order":147,
               "uuid":"H17mL9LbJY"
            },
            {
               "id":149,
               "label":"RI",
               "label_1":"",
               "group":"BLOOD_GAS",
               "key":"bg_ri",
               "isSwitchedCUS1":false,
               "isSwitchedCUS2":false,
               "isSwitchedCUS3":false,
               "isNumberic":true,
               "order":148,
               "uuid":"fp8DlSD3M3"
            },
            {
               "id":150,
               "label":"RI(T)",
               "label_1":"",
               "group":"BLOOD_GAS",
               "key":"bg_rit",
               "isSwitchedCUS1":false,
               "isSwitchedCUS2":false,
               "isSwitchedCUS3":false,
               "isNumberic":true,
               "order":149,
               "uuid":"Hwk2DNyQQf"
            },
            {
               "id":151,
               "label":"ctO2(a)",
               "label_1":"",
               "group":"BLOOD_GAS",
               "key":"bg_cto2a",
               "isSwitchedCUS1":false,
               "isSwitchedCUS2":false,
               "isSwitchedCUS3":false,
               "isNumberic":true,
               "order":150,
               "uuid":"NVW3x5M61H"
            },
            {
               "id":152,
               "label":"ct02(B)",
               "label_1":"",
               "group":"BLOOD_GAS",
               "key":"bg_cto2b",
               "isSwitchedCUS1":false,
               "isSwitchedCUS2":false,
               "isSwitchedCUS3":false,
               "isNumberic":true,
               "order":151,
               "uuid":"H5j7RZgz3G"
            },
            {
               "id":153,
               "label":"ctO2(v)",
               "label_1":"",
               "group":"BLOOD_GAS",
               "key":"bg_cto2v",
               "isSwitchedCUS1":false,
               "isSwitchedCUS2":false,
               "isSwitchedCUS3":false,
               "isNumberic":true,
               "order":152,
               "uuid":"4jk5xggc5i"
            },
            {
               "id":154,
               "label":"ctO2(a-v)",
               "label_1":"",
               "group":"BLOOD_GAS",
               "key":"bg_cto2av",
               "isSwitchedCUS1":false,
               "isSwitchedCUS2":false,
               "isSwitchedCUS3":false,
               "isNumberic":true,
               "order":153,
               "uuid":"Ge0M7ILNHg"
            },
            {
               "id":155,
               "label":"ctO2([a-v]/a)",
               "label_1":"",
               "group":"BLOOD_GAS",
               "key":"bg_cto2ava",
               "isSwitchedCUS1":false,
               "isSwitchedCUS2":false,
               "isSwitchedCUS3":false,
               "isNumberic":true,
               "order":154,
               "uuid":"eqbVys42dF"
            },
            {
               "id":156,
               "label":"Height",
               "label_1":"",
               "group":"BLOOD_GAS",
               "key":"bg_h",
               "isSwitchedCUS1":false,
               "isSwitchedCUS2":false,
               "isSwitchedCUS3":false,
               "isNumberic":true,
               "order":155,
               "uuid":"zDCOkGVvds"
            },
            {
               "id":157,
               "label":"Weight",
               "label_1":"",
               "group":"BLOOD_GAS",
               "key":"bg_w",
               "isSwitchedCUS1":false,
               "isSwitchedCUS2":false,
               "isSwitchedCUS3":false,
               "isNumberic":true,
               "order":156,
               "uuid":"AgeJazxG3o"
            },
            {
               "id":158,
               "label":"Patient's body temperature",
               "label_1":"",
               "group":"BLOOD_GAS",
               "key":"bg_ptmp",
               "isSwitchedCUS1":false,
               "isSwitchedCUS2":false,
               "isSwitchedCUS3":false,
               "isNumberic":true,
               "order":157,
               "uuid":"nbtCrgGerm"
            }
         ],

        dataLabParamsMaster_1: [
            { 
              "id" : 1 , 
              "label"  : "WBC", 
              "label_1"  : "White blood cell count", 
              "group" : "HEMATOLOGY",
              "key" : "hm_wbc" ,
              "isSwitchedCUS1" : true ,
              "isSwitchedCUS2" : false ,
              "isSwitchedCUS3" : false , 
              "isNumberic" :  true  ,
              "order" : null,
              "uuid" : ""
            } ,

            { 
                "id" : 2 , 
                "label"  : "NEUT %", 
                "label_1"  : "Percent Neutrophil count", 
                "group" : "HEMATOLOGY",
                "key" : "hm_segs" ,
                "isSwitchedCUS1" : true ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,

            { 
                "id" : 3 , 
                "label"  : "LYMPH %", 
                "label_1"  : "Percent Lymphocyte count", 
                "group" : "HEMATOLOGY",
                "key" : "hm_lymph" ,
                "isSwitchedCUS1" : true ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" : 4 , 
                "label"  : "MONO %", 
                "label_1"  : "Percent Monocyte count", 
                "group" : "HEMATOLOGY",
                "key" : "hm_mono" ,
                "isSwitchedCUS1" : true ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" : 5 , 
                "label"  : "EO %", 
                "label_1"  : "Percent Eosinophil count", 
                "group" : "HEMATOLOGY",
                "key" : "hm_eos" ,
                "isSwitchedCUS1" : true ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" : 6 , 
                "label"  : "BASO %", 
                "label_1"  : "Percent Basophil count", 
                "group" : "HEMATOLOGY",
                "key" : "hm_baso" ,
                "isSwitchedCUS1" : true ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" : 7 , 
                "label"  : "NEUT #", 
                "label_1"  : "Number of Neutrophils", 
                "group" : "HEMATOLOGY",
                "key" : "hm_neut" ,
                "isSwitchedCUS1" : true ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" : 8 , 
                "label"  : "LYMPH # ", 
                "label_1"  : "Number of Lymphocytes", 
                "group" : "HEMATOLOGY",
                "key" : "hm_lymph1" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" : 9 , 
                "label"  : "MONO # ", 
                "label_1"  : "Number of Lymphocytes", 
                "group" : "HEMATOLOGY",
                "key" : "hm_mono1" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" : 10 , 
                "label"  : "EO #", 
                "label_1"  : "Number of Eosinophils", 
                "group" : "HEMATOLOGY",
                "key" : "hm_eo" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" : 11 , 
                "label"  : "BASO # ", 
                "label_1"  : "Number of Basophils", 
                "group" : "HEMATOLOGY",
                "key" : "hm_baso1" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" : 12 , 
                "label"  : "NRBC % ", 
                "label_1"  : "Percent of nucleated red blood cells", 
                "group" : "HEMATOLOGY",
                "key" : "hm_nucl_rbc" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" : 13 , 
                "label"  : "NRBC #", 
                "label_1"  : "Number of nucleated red blood cells", 
                "group" : "HEMATOLOGY",
                "key" : "hm_nrbc" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" : 14 , 
                "label"  : "MY CYTE", 
                "label_1"  : "Myelocyte", 
                "group" : "HEMATOLOGY",
                "key" :   "hm_my_cyte" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" : 15 , 
                "label"  : "META", 
                "label_1"  : "Metamyelocyte", 
                "group" : "HEMATOLOGY",
                "key" : "hm_meta" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" : 16 , 
                "label"  : "Blast cell", 
                "label_1"  : "Blast cell", 
                "group" : "HEMATOLOGY",
                "key" : "hm_blascell" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" : 17 , 
                "label"  : "Mast cell", 
                "label_1"  : "Mast cell", 
                "group" : "HEMATOLOGY",
                "key" : "hm_mastcell" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" : 18 , 
                "label"  : "Band", 
                "label_1"  : "Band neutrophil", 
                "group" : "HEMATOLOGY",
                "key" : "hm_band" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" : 19 , 
                "label"  : "UNCLASS", 
                "label_1"  : "Unclassified", 
                "group" : "HEMATOLOGY",
                "key" : "hm_unclass" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" : 20 , 
                "label"  : "RBC", 
                "label_1"  : "Total number of erythrocytes", 
                "group" : "HEMATOLOGY",
                "key" : "hm_rbc" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" : 21 , 
                "label"  : "HGB", 
                "label_1"  : "Hemoglobin concentration", 
                "group" : "HEMATOLOGY",
                "key" : "hm_hgb" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" : 22 , 
                "label"  : "Hematocrit", 
                "label_1"  : "Hematocrit value", 
                "group" : "HEMATOLOGY",
                "key" : "hm_pcv" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" : 23 , 
                "label"  : "PCV ปั่น", 
                "label_1"  : "Packed cell volume", 
                "group" : "HEMATOLOGY",
                "key" : "hm_pcv1" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" : 24 , 
                "label"  : "MCV", 
                "label_1"  : "Mean erythrocyte volume in total sample", 
                "group" : "HEMATOLOGY",
                "key" : "hm_mcv" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" : 25 , 
                "label"  : "MCH", 
                "label_1"  : "Mean hemoglobin volume per  RBC count", 
                "group" : "HEMATOLOGY",
                "key" : "hm_mch" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" : 26 , 
                "label"  : "MCHC", 
                "label_1"  : "Mean hemoglobin concentration of erythrocytes", 
                "group" : "HEMATOLOGY",
                "key" : "hm_mchc" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" : 27 , 
                "label"  : "RDW-SD", 
                "label_1"  : "Red Cell Distribution Width (standard deviation)", 
                "group" : "HEMATOLOGY",
                "key" : "hm_rdw" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" : 28 , 
                "label"  : "RDW-CV", 
                "label_1"  : "Red Cell Distribution Width (coefficient of variation)", 
                "group" : "HEMATOLOGY",
                "key" : "hm_rdwc" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" : 29 , 
                "label"  : "PLT - I", 
                "label_1"  : "Platelet Impedant", 
                "group" : "HEMATOLOGY",
                "key" : "hm_plti" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" : 30 , 
                "label"  : "PLT - O", 
                "label_1"  : "Platelet Optical", 
                "group" : "HEMATOLOGY",
                "key" : "hm_plto" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" : 31 , 
                "label"  : "PLT - count", 
                "label_1"  : "Platelet count", 
                "group" : "HEMATOLOGY",
                "key" : "hm_platelets" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" :  32, 
                "label"  : "MPV", 
                "label_1"  : "Mean platelet volume", 
                "group" : "HEMATOLOGY",
                "key" : "hm_mpv" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" : 33  , 
                "label"  : "PDW", 
                "label_1"  : "Platelet distribution width", 
                "group" : "HEMATOLOGY",
                "key" : "hm_pdw" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" : 34 , 
                "label"  : "P-LCR", 
                "label_1"  : "Platelet-large cell ratio", 
                "group" : "HEMATOLOGY",
                "key" : "hm_plcr" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" : 35 , 
                "label"  : "PCT", 
                "label_1"  : "Plateletcrit", 
                "group" : "HEMATOLOGY",
                "key" : "hm_pct" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" :  36 , 
                "label"  : "RET%", 
                "label_1"  : "Reticulocyte percent", 
                "group" : "HEMATOLOGY",
                "key" : "hm_retics" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" : 37 , 
                "label"  : "RET#", 
                "label_1"  : "Reticulocyte count", 
                "group" : "HEMATOLOGY",
                "key" : "hm_ret1" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" :  38 , 
                "label"  : "IRF", 
                "label_1"  : "Immature reticulocyte fraction", 
                "group" : "HEMATOLOGY",
                "key" : "hm_irf" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" : 39 , 
                "label"  : "LFR", 
                "label_1"  : "Low fluorescence ratio", 
                "group" : "HEMATOLOGY",
                "key" : "hm_lfr" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" : 40 , 
                "label"  : "HFR", 
                "label_1"  : "High fluorescence ratio", 
                "group" : "HEMATOLOGY",
                "key" : "hm_hfr" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" : 41 , 
                "label"  : "RET-He", 
                "label_1"  : "Reticulocyte hemoglobin equivalent", 
                "group" : "HEMATOLOGY",
                "key" : "hm_ret_he" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" : 42 , 
                "label"  : "RPI", 
                "label_1"  : "Reticulocyte Production Index", 
                "group" : "HEMATOLOGY",
                "key" : "hm_rpi" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" : 43 , 
                "label"  : "PP", 
                "label_1"  : "Plasma proteins", 
                "group" : "HEMATOLOGY",
                "key" : "hm_protein_refract " ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,








            { 
                "id" : 44 , 
                "label"  : "WBC-BF", 
                "label_1"  : "White blood cell (leukocyte) count", 
                "group" : "BODY_FLUID",
                "key" : "bf_wbcbf" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" : 45 , 
                "label"  : "RBC-BF", 
                "label_1"  : "Red blood cell (erythrocyte) count", 
                "group" : "BODY_FLUID",
                "key" : "bf_rbcbf" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" : 46 , 
                "label"  : "MN#", 
                "label_1"  : "Mononuclear count", 
                "group" : "BODY_FLUID",
                "key" : "BF_MN" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true  ,
                "order" : null ,
                "uuid" : ""
            } ,
            { 
                "id" : 47 , 
                "label"  : "PMN#", 
                "label_1"  : "Polymorphonuclear count", 
                "group" : "BODY_FLUID",
                "key" : "bf_pmn" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" : 48 , 
                "label"  : "MN%", 
                "label_1"  : "Mononuclear percent", 
                "group" : "BODY_FLUID",
                "key" : "bf_mn1" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" : 49  , 
                "label"  : "PMN%", 
                "label_1"  : "Polymorphonuclear percent", 
                "group" : "BODY_FLUID",
                "key" : "bf_pmn1" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" : 50 , 
                "label"  : "TC-BF", 
                "label_1"  : "Total nucleated cell count", 
                "group" : "BODY_FLUID",
                "key" : "BF_TCBF" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,









            { 
                "id" :  51, 
                "label"  : "BUN", 
                "label_1"  : "Blood urea nitrogen", 
                "group" : "BLOOD_CHEMISTRY",
                "key" : "bc_bun" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" : 52 , 
                "label"  : "CREA", 
                "label_1"  : "Creatinine", 
                "group" : "BLOOD_CHEMISTRY",
                "key" : "bc_creatinine" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" : 53 , 
                "label"  : "URIC", 
                "label_1"  : "Uric acid", 
                "group" : "BLOOD_CHEMISTRY",
                "key" : "bc_uric" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" : 54  , 
                "label"  : "CHOL", 
                "label_1"  : "Cholesterol", 
                "group" : "BLOOD_CHEMISTRY",
                "key" : "bc_cholesterol" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" : 55  , 
                "label"  : "TRIG", 
                "label_1"  : "Triglycerides", 
                "group" : "BLOOD_CHEMISTRY",
                "key" : "bc_triglyceride" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" : 56  , 
                "label"  : "TP", 
                "label_1"  : "Total protein", 
                "group" : "BLOOD_CHEMISTRY",
                "key" : "bc_protein_biuret" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" :  57  , 
                "label"  : "ALB", 
                "label_1"  : "Albumin", 
                "group" : "BLOOD_CHEMISTRY",
                "key" : "bc_albumin" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" :  58 , 
                "label"  : "Glob", 
                "label_1"  : "Globulin", 
                "group" : "BLOOD_CHEMISTRY",
                "key" : "bc_glob" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true  ,
                "order" : null ,
                "uuid" : ""
            } ,
            { 
                "id" : 59  , 
                "label"  : "TBIL", 
                "label_1"  : "Total bilirubin", 
                "group" : "BLOOD_CHEMISTRY",
                "key" : "bc_bilirubin_total" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" : 60  , 
                "label"  : "DBIL", 
                "label_1"  : "Direct Bilirubin", 
                "group" : "BLOOD_CHEMISTRY",
                "key" : "bc_direct" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" : 61  , 
                "label"  : "AST", 
                "label_1"  : "Aspartate aminotransferase", 
                "group" : "BLOOD_CHEMISTRY",
                "key" : "bc_ast_sgot" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" :  62 , 
                "label"  : "ALT", 
                "label_1"  : "Alanine aminotransferase", 
                "group" : "BLOOD_CHEMISTRY",
                "key" : "bc_alt_sgpt" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" :  63 , 
                "label"  : "ALP", 
                "label_1"  : "Alkaline phosphatase", 
                "group" : "BLOOD_CHEMISTRY",
                "key" : "bc_alk_phos" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" : 64  , 
                "label"  : "CSF", 
                "label_1"  : "Cerebrospinal Fluid Protein", 
                "group" : "BLOOD_CHEMISTRY",
                "key" : "bc_csf" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" :  65  , 
                "label"  : "GGT", 
                "label_1"  : "Gamma-glutaamyltransferase", 
                "group" : "BLOOD_CHEMISTRY",
                "key" : "bc_ggt" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" :  66 , 
                "label"  : "Ca", 
                "label_1"  : "Calcium", 
                "group" : "BLOOD_CHEMISTRY",
                "key" : "bc_calcium" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" : 67  , 
                "label"  : "PHOS", 
                "label_1"  : "Inorganic phosphorus", 
                "group" : "BLOOD_CHEMISTRY",
                "key" : "bc_phosphorus" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" :  68  , 
                "label"  : "Sodium", 
                "label_1"  : "Sodium", 
                "group" : "BLOOD_CHEMISTRY",
                "key" : "bc_sodium" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" :   69   , 
                "label"  : "Potassium", 
                "label_1"  : "Potassium", 
                "group" : "BLOOD_CHEMISTRY",
                "key" : "bc_potassium" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" :  70 , 
                "label"  : "Chloride", 
                "label_1"  : "Chloride", 
                "group" : "BLOOD_CHEMISTRY",
                "key" : "bc_chloride" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" :  71   , 
                "label"  : "CK", 
                "label_1"  : "Creatinine kinase", 
                "group" : "BLOOD_CHEMISTRY",
                "key" : "bc_cpk" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" :  72 , 
                "label"  : "NH3", 
                "label_1"  : "Ammonia", 
                "group" : "BLOOD_CHEMISTRY",
                "key" : "bc_ammonia" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" :  73 , 
                "label"  : "GLU", 
                "label_1"  : "Glucose", 
                "group" : "BLOOD_CHEMISTRY",
                "key" : "bc_glucose" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" :   74  , 
                "label"  : "UCRE", 
                "label_1"  : "Urine creatinine", 
                "group" : "BLOOD_CHEMISTRY",
                "key" : "ur_creatinine" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" :  75 , 
                "label"  : "UPRO", 
                "label_1"  : "Urine protein", 
                "group" : "BLOOD_CHEMISTRY",
                "key" : "bc_upro" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" :  76 , 
                "label"  : "AMYL", 
                "label_1"  : "Amylase", 
                "group" : "BLOOD_CHEMISTRY",
                "key" : "bc_amylase" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" :  77  , 
                "label"  : "CRP", 
                "label_1"  : "C-reactive protein", 
                "group" : "BLOOD_CHEMISTRY",
                "key" : "bc_crp" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" :  78 , 
                "label"  : "SDMA", 
                "label_1"  : "Symmetric dimethylarginine", 
                "group" : "BLOOD_CHEMISTRY",
                "key" : "bc_sdma" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" :  79  , 
                "label"  : "TT4(T4)", 
                "label_1"  : "Total Thyroxine", 
                "group" : "BLOOD_CHEMISTRY",
                "key" : "bc_tt4" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" :  80 , 
                "label"  : "FRU", 
                "label_1"  : "Fructosamine", 
                "group" : "BLOOD_CHEMISTRY",
                "key" : "sp_fructo" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" :  81 , 
                "label"  : "LAC", 
                "label_1"  : "Lactate", 
                "group" : "BLOOD_CHEMISTRY",
                "key" : "bc_fru" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" :  82  , 
                "label"  : "LDH", 
                "label_1"  : "Lactate dehydrogenase", 
                "group" : "BLOOD_CHEMISTRY",
                "key" : "bc_lac" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" :  83 , 
                "label"  : "LIPA", 
                "label_1"  : "Lipase", 
                "group" : "BLOOD_CHEMISTRY",
                "key" : "sp_lipase" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" :  84  , 
                "label"  : "Mg", 
                "label_1"  : "Magnesium", 
                "group" : "BLOOD_CHEMISTRY",
                "key" : "bc_mg" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" :  85 , 
                "label"  : "PROG", 
                "label_1"  : "Progesterone", 
                "group" : "BLOOD_CHEMISTRY",
                "key" : "bc_prog" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" : 86  , 
                "label"  : "BA", 
                "label_1"  : "Bile acids", 
                "group" : "BLOOD_CHEMISTRY",
                "key" : "bc_bileacid_fasting" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,








            { 
                "id" : 87  , 
                "label"  : "cT4", 
                "label_1"  : "Canine thyroxine", 
                "group" : "HORMONE",
                "key" : "hom_t4" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" :  88 , 
                "label"  : "cTSH", 
                "label_1"  : "Canine thyroid stimulating hormone", 
                "group" : "HORMONE",
                "key" : "hom_ctsh" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" :  89 , 
                "label"  : "cTLI", 
                "label_1"  : "Canine trypsin-like immunoreactivity", 
                "group" : "HORMONE",
                "key" : "hom_ctli" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" :  90 , 
                "label"  : "PHBR", 
                "label_1"  : "Phenobarbitol", 
                "group" : "HORMONE",
                "key" : "sp_phenobarb" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" :  91 , 
                "label"  : "Cortisol", 
                "label_1"  : "Cortisol", 
                "group" : "HORMONE",
                "key" : "hom_cotis" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,






            { 
                "id" :  92 , 
                "label"  : "pH", 
                "label_1"  : "", 
                "group" : "BLOOD_GAS",
                "key" : "bg_ph" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" :  93 , 
                "label"  : "pCO2", 
                "label_1"  : "", 
                "group" : "BLOOD_GAS",
                "key" : "bg_pco2" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true  ,
                "order" : null ,
                "uuid" : ""
            } ,
            { 
                "id" :  94 , 
                "label"  : "pO2", 
                "label_1"  : "", 
                "group" : "BLOOD_GAS",
                "key" : "bg_po2" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" :  95 , 
                "label"  : "Na", 
                "label_1"  : "", 
                "group" : "BLOOD_GAS",
                "key" : "bg_na" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" :  96 , 
                "label"  : "K", 
                "label_1"  : "", 
                "group" : "BLOOD_GAS",
                "key" : "bg_k" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" :  97 , 
                "label"  : "Cl", 
                "label_1"  : "", 
                "group" : "BLOOD_GAS",
                "key" : "bg_ci" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" : 98  , 
                "label"  : "iCa", 
                "label_1"  : "", 
                "group" : "BLOOD_GAS",
                "key" : "bg_ca" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" :  99  , 
                "label"  : "Hb", 
                "label_1"  : "", 
                "group" : "BLOOD_GAS",
                "key" : "bg_hb" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" :  100  , 
                "label"  : "HCT", 
                "label_1"  : "", 
                "group" : "BLOOD_GAS",
                "key" : "bg_hct" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" :  101 , 
                "label"  : "HCO3-act", 
                "label_1"  : "", 
                "group" : "BLOOD_GAS",
                "key" : "bg_hco3" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" : 102  , 
                "label"  : "BE(B)", 
                "label_1"  : "", 
                "group" : "BLOOD_GAS",
                "key" : "bg_be" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" : 103  , 
                "label"  : "ctCO2(P)", 
                "label_1"  : "", 
                "group" : "BLOOD_GAS",
                "key" : "bg_ctco2" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" : 104  , 
                "label"  : "pH(T)", 
                "label_1"  : "", 
                "group" : "BLOOD_GAS",
                "key" : "bg_pht" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" : 105  , 
                "label"  : "pCO2(T)", 
                "label_1"  : "", 
                "group" : "BLOOD_GAS",
                "key" : "bg_pco2t" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" : 106  , 
                "label"  : "pO2(T)", 
                "label_1"  : "", 
                "group" : "BLOOD_GAS",
                "key" : "bg_po2t" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" : 107  , 
                "label"  : "sO2(est)", 
                "label_1"  : "", 
                "group" : "BLOOD_GAS",
                "key" : "bg_so2est" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" :  108   , 
                "label"  : "iCa(7.4)", 
                "label_1"  : "", 
                "group" : "BLOOD_GAS",
                "key" : "bg_ica" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" :  109  , 
                "label"  : "Glc", 
                "label_1"  : "", 
                "group" : "BLOOD_GAS",
                "key" : "bg_glc" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" :  110  , 
                "label"  : "Lac", 
                "label_1"  : "", 
                "group" : "BLOOD_GAS",
                "key" : "bg_lac" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" : 111  , 
                "label"  : "Temperature", 
                "label_1"  : "", 
                "group" : "BLOOD_GAS",
                "key" : "bg_temp" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" : 112  , 
                "label"  : "FIO2", 
                "label_1"  : "", 
                "group" : "BLOOD_GAS",
                "key" : "bg_fio2" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" :  113 , 
                "label"  : "BP", 
                "label_1"  : "", 
                "group" : "BLOOD_GAS",
                "key" : "bg_bp" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" : 114  , 
                "label"  : "HCO3-std", 
                "label_1"  : "", 
                "group" : "BLOOD_GAS",
                "key" : "bg_hco3std" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" : 115  , 
                "label"  : "BE(ecf)", 
                "label_1"  : "", 
                "group" : "BLOOD_GAS",
                "key" : "bg_beecf" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" :  116 , 
                "label"  : "cNa+", 
                "label_1"  : "", 
                "group" : "BLOOD_GAS",
                "key" : "bg_cna" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" :  117  , 
                "label"  : "cK+", 
                "label_1"  : "", 
                "group" : "BLOOD_GAS",
                "key" : "bg_ck" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" :  118   , 
                "label"  : "cCa2+", 
                "label_1"  : "", 
                "group" : "BLOOD_GAS",
                "key" : "bg_cca2" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" : 119  , 
                "label"  : "cCI-", 
                "label_1"  : "", 
                "group" : "BLOOD_GAS",
                "key" : "bg_cci" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" :  120 , 
                "label"  : "cGlc", 
                "label_1"  : "", 
                "group" : "BLOOD_GAS",
                "key" : "bg_cglc" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" : 121  , 
                "label"  : "cLac", 
                "label_1"  : "", 
                "group" : "BLOOD_GAS",
                "key" : "bg_clac" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" : 122  , 
                "label"  : "ctBil", 
                "label_1"  : "", 
                "group" : "BLOOD_GAS",
                "key" : "bg_ctbil" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" : 123  , 
                "label"  : "ctHb", 
                "label_1"  : "", 
                "group" : "BLOOD_GAS",
                "key" : "bg_cthb" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" :  124  , 
                "label"  : "FHHb", 
                "label_1"  : "", 
                "group" : "BLOOD_GAS",
                "key" : "bg_fhhb" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" :  125 , 
                "label"  : "FO2Hb", 
                "label_1"  : "", 
                "group" : "BLOOD_GAS",
                "key" : "bg_fo2hb" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" :   126 , 
                "label"  : "FCOHb", 
                "label_1"  : "", 
                "group" : "BLOOD_GAS",
                "key" : "bg_fcohb" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" : 127  , 
                "label"  : "FMetHb", 
                "label_1"  : "", 
                "group" : "BLOOD_GAS",
                "key" : "bg_fmethb" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" :  128  , 
                "label"  : "sO2", 
                "label_1"  : "", 
                "group" : "BLOOD_GAS",
                "key" : "bg_so2" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" : 129  , 
                "label"  : "AG", 
                "label_1"  : "", 
                "group" : "BLOOD_GAS",
                "key" : "bg_ag" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" : 130  , 
                "label"  : "AG(K)", 
                "label_1"  : "", 
                "group" : "BLOOD_GAS",
                "key" : "bg_agk" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true  ,
                "order" : null  ,
                "uuid" : ""
            } ,
            { 
                "id" :  131  , 
                "label"  : "cHCO3- act", 
                "label_1"  : "", 
                "group" : "BLOOD_GAS",
                "key" : "bg_chact" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" :  132 , 
                "label"  : "cHCO3- std", 
                "label_1"  : "", 
                "group" : "BLOOD_GAS",
                "key" : "bg_chstd" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" :  133 , 
                "label"  : "cBE(ecf)", 
                "label_1"  : "", 
                "group" : "BLOOD_GAS",
                "key" : "bg_cbeecf" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" :  134   , 
                "label"  : "CBE(B)", 
                "label_1"  : "", 
                "group" : "BLOOD_GAS",
                "key" : "BG_CBEB" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true  ,
                "order" : null ,
                "uuid" : ""
            } ,
            { 
                "id" :  135 , 
                "label"  : "cBB", 
                "label_1"  : "", 
                "group" : "BLOOD_GAS",
                "key" : "bg_cbb" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" :  136  , 
                "label"  : "ctCO2(B)", 
                "label_1"  : "", 
                "group" : "BLOOD_GAS",
                "key" : "bg_ctco2b" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            // { 
            //     "id" :  137  , 
            //     "label"  : "Hct", 
            //     "label_1"  : "", 
            //     "group" : "BLOOD_GAS",
            //     "key" : "bg_hct" ,
            //     "isSwitchedCUS1" : false ,
            //     "isSwitchedCUS2" : false ,
            //     "isSwitchedCUS3" : false , 
            //     "isNumberic" :  true  
            // } ,
            { 
                "id" :  137  , 
                "label"  : "BO2", 
                "label_1"  : "", 
                "group" : "BLOOD_GAS",
                "key" : "bg_bo2" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" :  138  , 
                "label"  : "p50", 
                "label_1"  : "", 
                "group" : "BLOOD_GAS",
                "key" : "bg_p50" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" :  139   , 
                "label"  : "p50(T)", 
                "label_1"  : "", 
                "group" : "BLOOD_GAS",
                "key" : "bg_p50t" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" :  140  , 
                "label"  : "p50(st)", 
                "label_1"  : "", 
                "group" : "BLOOD_GAS",
                "key" : "bg_p50st" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" :  141  , 
                "label"  : "pO2/FiO2", 
                "label_1"  : "", 
                "group" : "BLOOD_GAS",
                "key" : "bg_po2fio2" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" :  142  , 
                "label"  : "cCa2+ (7.4)", 
                "label_1"  : "", 
                "group" : "BLOOD_GAS",
                "key" : "bg_cca2p" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" :  143  , 
                "label"  : "pO2(A)", 
                "label_1"  : "", 
                "group" : "BLOOD_GAS",
                "key" : "bg_po2a" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" :  144   , 
                "label"  : "pO2(A)(T)", 
                "label_1"  : "", 
                "group" : "BLOOD_GAS",
                "key" : "bg_po2at" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" :  145  , 
                "label"  : "pO2(A-a)", 
                "label_1"  : "", 
                "group" : "BLOOD_GAS",
                "key" : "bg_po2aa" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" :  146  , 
                "label"  : "pO2(A-a)(T)", 
                "label_1"  : "", 
                "group" : "BLOOD_GAS",
                "key" : "bg_po2aat" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" :  147  , 
                "label"  : "pO2(a/A)", 
                "label_1"  : "", 
                "group" : "BLOOD_GAS",
                "key" : "bg_po2aa1" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" :  148   , 
                "label"  : "pO2(a/A)(T)", 
                "label_1"  : "", 
                "group" : "BLOOD_GAS",
                "key" : "bg_po2aat1" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" :  149  , 
                "label"  : "RI", 
                "label_1"  : "", 
                "group" : "BLOOD_GAS",
                "key" : "bg_ri" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" : 150   , 
                "label"  : "RI(T)", 
                "label_1"  : "", 
                "group" : "BLOOD_GAS",
                "key" : "bg_rit" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" :  151  , 
                "label"  : "ctO2(a)", 
                "label_1"  : "", 
                "group" : "BLOOD_GAS",
                "key" : "bg_cto2a" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" :  152  , 
                "label"  : "ct02(B)", 
                "label_1"  : "", 
                "group" : "BLOOD_GAS",
                "key" : "bg_cto2b" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" :  153  , 
                "label"  : "ctO2(v)", 
                "label_1"  : "", 
                "group" : "BLOOD_GAS",
                "key" : "bg_cto2v" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" :  154   , 
                "label"  : "ctO2(a-v)", 
                "label_1"  : "", 
                "group" : "BLOOD_GAS",
                "key" : "bg_cto2av" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" :  155   , 
                "label"  : "ctO2([a-v]/a)", 
                "label_1"  : "", 
                "group" : "BLOOD_GAS",
                "key" : "bg_cto2ava" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" :  156  , 
                "label"  : "Height", 
                "label_1"  : "", 
                "group" : "BLOOD_GAS",
                "key" : "bg_h" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" :  157  , 
                "label"  : "Weight", 
                "label_1"  : "", 
                "group" : "BLOOD_GAS",
                "key" : "bg_w" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" :  158  , 
                "label"  : "Patient's body temperature", 
                "label_1"  : "", 
                "group" : "BLOOD_GAS",
                "key" : "bg_ptmp" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,







     

        ],

        dataLabParamsMaster_2: [
            { 
              "id" : 1 , 
              "label"  : "WBC", 
              "label_1"  : "White blood cell count", 
              "group" : "HEMATOLOGY",
              "key" : "hm_wbc" ,
              "isSwitchedCUS1" : true ,
              "isSwitchedCUS2" : false ,
              "isSwitchedCUS3" : false , 
              "isNumberic" :  true  ,
              "order" : null,
              "uuid" : ""
            } ,

            { 
                "id" : 2 , 
                "label"  : "NEUT %", 
                "label_1"  : "Percent Neutrophil count", 
                "group" : "HEMATOLOGY",
                "key" : "hm_segs" ,
                "isSwitchedCUS1" : true ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,

            { 
                "id" : 3 , 
                "label"  : "LYMPH %", 
                "label_1"  : "Percent Lymphocyte count", 
                "group" : "HEMATOLOGY",
                "key" : "hm_lymph" ,
                "isSwitchedCUS1" : true ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" : 4 , 
                "label"  : "MONO %", 
                "label_1"  : "Percent Monocyte count", 
                "group" : "HEMATOLOGY",
                "key" : "hm_mono" ,
                "isSwitchedCUS1" : true ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" : 5 , 
                "label"  : "EO %", 
                "label_1"  : "Percent Eosinophil count", 
                "group" : "HEMATOLOGY",
                "key" : "hm_eos" ,
                "isSwitchedCUS1" : true ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" : 6 , 
                "label"  : "BASO %", 
                "label_1"  : "Percent Basophil count", 
                "group" : "HEMATOLOGY",
                "key" : "hm_baso" ,
                "isSwitchedCUS1" : true ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" : 7 , 
                "label"  : "NEUT #", 
                "label_1"  : "Number of Neutrophils", 
                "group" : "HEMATOLOGY",
                "key" : "hm_neut" ,
                "isSwitchedCUS1" : true ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" : 8 , 
                "label"  : "LYMPH # ", 
                "label_1"  : "Number of Lymphocytes", 
                "group" : "HEMATOLOGY",
                "key" : "hm_lymph1" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" : 9 , 
                "label"  : "MONO # ", 
                "label_1"  : "Number of Lymphocytes", 
                "group" : "HEMATOLOGY",
                "key" : "hm_mono1" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" : 10 , 
                "label"  : "EO #", 
                "label_1"  : "Number of Eosinophils", 
                "group" : "HEMATOLOGY",
                "key" : "hm_eo" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" : 11 , 
                "label"  : "BASO # ", 
                "label_1"  : "Number of Basophils", 
                "group" : "HEMATOLOGY",
                "key" : "hm_baso1" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" : 12 , 
                "label"  : "NRBC % ", 
                "label_1"  : "Percent of nucleated red blood cells", 
                "group" : "HEMATOLOGY",
                "key" : "hm_nucl_rbc" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" : 13 , 
                "label"  : "NRBC #", 
                "label_1"  : "Number of nucleated red blood cells", 
                "group" : "HEMATOLOGY",
                "key" : "hm_nrbc" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" : 14 , 
                "label"  : "MY CYTE", 
                "label_1"  : "Myelocyte", 
                "group" : "HEMATOLOGY",
                "key" :   "hm_my_cyte" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" : 15 , 
                "label"  : "META", 
                "label_1"  : "Metamyelocyte", 
                "group" : "HEMATOLOGY",
                "key" : "hm_meta" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" : 16 , 
                "label"  : "Blast cell", 
                "label_1"  : "Blast cell", 
                "group" : "HEMATOLOGY",
                "key" : "hm_blascell" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" : 17 , 
                "label"  : "Mast cell", 
                "label_1"  : "Mast cell", 
                "group" : "HEMATOLOGY",
                "key" : "hm_mastcell" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" : 18 , 
                "label"  : "Band", 
                "label_1"  : "Band neutrophil", 
                "group" : "HEMATOLOGY",
                "key" : "hm_band" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" : 19 , 
                "label"  : "UNCLASS", 
                "label_1"  : "Unclassified", 
                "group" : "HEMATOLOGY",
                "key" : "hm_unclass" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" : 20 , 
                "label"  : "RBC", 
                "label_1"  : "Total number of erythrocytes", 
                "group" : "HEMATOLOGY",
                "key" : "hm_rbc" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" : 21 , 
                "label"  : "HGB", 
                "label_1"  : "Hemoglobin concentration", 
                "group" : "HEMATOLOGY",
                "key" : "hm_hgb" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" : 22 , 
                "label"  : "Hematocrit", 
                "label_1"  : "Hematocrit value", 
                "group" : "HEMATOLOGY",
                "key" : "hm_pcv" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" : 23 , 
                "label"  : "PCV ปั่น", 
                "label_1"  : "Packed cell volume", 
                "group" : "HEMATOLOGY",
                "key" : "hm_pcv1" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" : 24 , 
                "label"  : "MCV", 
                "label_1"  : "Mean erythrocyte volume in total sample", 
                "group" : "HEMATOLOGY",
                "key" : "hm_mcv" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" : 25 , 
                "label"  : "MCH", 
                "label_1"  : "Mean hemoglobin volume per  RBC count", 
                "group" : "HEMATOLOGY",
                "key" : "hm_mch" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" : 26 , 
                "label"  : "MCHC", 
                "label_1"  : "Mean hemoglobin concentration of erythrocytes", 
                "group" : "HEMATOLOGY",
                "key" : "hm_mchc" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" : 27 , 
                "label"  : "RDW-SD", 
                "label_1"  : "Red Cell Distribution Width (standard deviation)", 
                "group" : "HEMATOLOGY",
                "key" : "hm_rdw" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" : 28 , 
                "label"  : "RDW-CV", 
                "label_1"  : "Red Cell Distribution Width (coefficient of variation)", 
                "group" : "HEMATOLOGY",
                "key" : "hm_rdwc" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" : 29 , 
                "label"  : "PLT - I", 
                "label_1"  : "Platelet Impedant", 
                "group" : "HEMATOLOGY",
                "key" : "hm_plti" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" : 30 , 
                "label"  : "PLT - O", 
                "label_1"  : "Platelet Optical", 
                "group" : "HEMATOLOGY",
                "key" : "hm_plto" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" : 31 , 
                "label"  : "PLT - count", 
                "label_1"  : "Platelet count", 
                "group" : "HEMATOLOGY",
                "key" : "hm_platelets" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" :  32, 
                "label"  : "MPV", 
                "label_1"  : "Mean platelet volume", 
                "group" : "HEMATOLOGY",
                "key" : "hm_mpv" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" : 33  , 
                "label"  : "PDW", 
                "label_1"  : "Platelet distribution width", 
                "group" : "HEMATOLOGY",
                "key" : "hm_pdw" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" : 34 , 
                "label"  : "P-LCR", 
                "label_1"  : "Platelet-large cell ratio", 
                "group" : "HEMATOLOGY",
                "key" : "hm_plcr" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" : 35 , 
                "label"  : "PCT", 
                "label_1"  : "Plateletcrit", 
                "group" : "HEMATOLOGY",
                "key" : "hm_pct" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" :  36 , 
                "label"  : "RET%", 
                "label_1"  : "Reticulocyte percent", 
                "group" : "HEMATOLOGY",
                "key" : "hm_retics" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" : 37 , 
                "label"  : "RET#", 
                "label_1"  : "Reticulocyte count", 
                "group" : "HEMATOLOGY",
                "key" : "hm_ret1" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" :  38 , 
                "label"  : "IRF", 
                "label_1"  : "Immature reticulocyte fraction", 
                "group" : "HEMATOLOGY",
                "key" : "hm_irf" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" : 39 , 
                "label"  : "LFR", 
                "label_1"  : "Low fluorescence ratio", 
                "group" : "HEMATOLOGY",
                "key" : "hm_lfr" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" : 40 , 
                "label"  : "HFR", 
                "label_1"  : "High fluorescence ratio", 
                "group" : "HEMATOLOGY",
                "key" : "hm_hfr" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" : 41 , 
                "label"  : "RET-He", 
                "label_1"  : "Reticulocyte hemoglobin equivalent", 
                "group" : "HEMATOLOGY",
                "key" : "hm_ret_he" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" : 42 , 
                "label"  : "RPI", 
                "label_1"  : "Reticulocyte Production Index", 
                "group" : "HEMATOLOGY",
                "key" : "hm_rpi" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" : 43 , 
                "label"  : "PP", 
                "label_1"  : "Plasma proteins", 
                "group" : "HEMATOLOGY",
                "key" : "hm_protein_refract " ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,








            { 
                "id" : 44 , 
                "label"  : "WBC-BF", 
                "label_1"  : "White blood cell (leukocyte) count", 
                "group" : "BODY_FLUID",
                "key" : "bf_wbcbf" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" : 45 , 
                "label"  : "RBC-BF", 
                "label_1"  : "Red blood cell (erythrocyte) count", 
                "group" : "BODY_FLUID",
                "key" : "bf_rbcbf" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" : 46 , 
                "label"  : "MN#", 
                "label_1"  : "Mononuclear count", 
                "group" : "BODY_FLUID",
                "key" : "BF_MN" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true  ,
                "order" : null ,
                "uuid" : ""
            } ,
            { 
                "id" : 47 , 
                "label"  : "PMN#", 
                "label_1"  : "Polymorphonuclear count", 
                "group" : "BODY_FLUID",
                "key" : "bf_pmn" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" : 48 , 
                "label"  : "MN%", 
                "label_1"  : "Mononuclear percent", 
                "group" : "BODY_FLUID",
                "key" : "bf_mn1" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" : 49  , 
                "label"  : "PMN%", 
                "label_1"  : "Polymorphonuclear percent", 
                "group" : "BODY_FLUID",
                "key" : "bf_pmn1" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" : 50 , 
                "label"  : "TC-BF", 
                "label_1"  : "Total nucleated cell count", 
                "group" : "BODY_FLUID",
                "key" : "BF_TCBF" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,









            { 
                "id" :  51, 
                "label"  : "BUN", 
                "label_1"  : "Blood urea nitrogen", 
                "group" : "BLOOD_CHEMISTRY",
                "key" : "bc_bun" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" : 52 , 
                "label"  : "CREA", 
                "label_1"  : "Creatinine", 
                "group" : "BLOOD_CHEMISTRY",
                "key" : "bc_creatinine" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" : 53 , 
                "label"  : "URIC", 
                "label_1"  : "Uric acid", 
                "group" : "BLOOD_CHEMISTRY",
                "key" : "bc_uric" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" : 54  , 
                "label"  : "CHOL", 
                "label_1"  : "Cholesterol", 
                "group" : "BLOOD_CHEMISTRY",
                "key" : "bc_cholesterol" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" : 55  , 
                "label"  : "TRIG", 
                "label_1"  : "Triglycerides", 
                "group" : "BLOOD_CHEMISTRY",
                "key" : "bc_triglyceride" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" : 56  , 
                "label"  : "TP", 
                "label_1"  : "Total protein", 
                "group" : "BLOOD_CHEMISTRY",
                "key" : "bc_protein_biuret" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" :  57  , 
                "label"  : "ALB", 
                "label_1"  : "Albumin", 
                "group" : "BLOOD_CHEMISTRY",
                "key" : "bc_albumin" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" :  58 , 
                "label"  : "Glob", 
                "label_1"  : "Globulin", 
                "group" : "BLOOD_CHEMISTRY",
                "key" : "bc_glob" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true  ,
                "order" : null ,
                "uuid" : ""
            } ,
            { 
                "id" : 59  , 
                "label"  : "TBIL", 
                "label_1"  : "Total bilirubin", 
                "group" : "BLOOD_CHEMISTRY",
                "key" : "bc_bilirubin_total" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" : 60  , 
                "label"  : "DBIL", 
                "label_1"  : "Direct Bilirubin", 
                "group" : "BLOOD_CHEMISTRY",
                "key" : "bc_direct" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" : 61  , 
                "label"  : "AST", 
                "label_1"  : "Aspartate aminotransferase", 
                "group" : "BLOOD_CHEMISTRY",
                "key" : "bc_ast_sgot" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" :  62 , 
                "label"  : "ALT", 
                "label_1"  : "Alanine aminotransferase", 
                "group" : "BLOOD_CHEMISTRY",
                "key" : "bc_alt_sgpt" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" :  63 , 
                "label"  : "ALP", 
                "label_1"  : "Alkaline phosphatase", 
                "group" : "BLOOD_CHEMISTRY",
                "key" : "bc_alk_phos" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" : 64  , 
                "label"  : "CSF", 
                "label_1"  : "Cerebrospinal Fluid Protein", 
                "group" : "BLOOD_CHEMISTRY",
                "key" : "bc_csf" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" :  65  , 
                "label"  : "GGT", 
                "label_1"  : "Gamma-glutaamyltransferase", 
                "group" : "BLOOD_CHEMISTRY",
                "key" : "bc_ggt" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" :  66 , 
                "label"  : "Ca", 
                "label_1"  : "Calcium", 
                "group" : "BLOOD_CHEMISTRY",
                "key" : "bc_calcium" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" : 67  , 
                "label"  : "PHOS", 
                "label_1"  : "Inorganic phosphorus", 
                "group" : "BLOOD_CHEMISTRY",
                "key" : "bc_phosphorus" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" :  68  , 
                "label"  : "Sodium", 
                "label_1"  : "Sodium", 
                "group" : "BLOOD_CHEMISTRY",
                "key" : "bc_sodium" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" :   69   , 
                "label"  : "Potassium", 
                "label_1"  : "Potassium", 
                "group" : "BLOOD_CHEMISTRY",
                "key" : "bc_potassium" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" :  70 , 
                "label"  : "Chloride", 
                "label_1"  : "Chloride", 
                "group" : "BLOOD_CHEMISTRY",
                "key" : "bc_chloride" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" :  71   , 
                "label"  : "CK", 
                "label_1"  : "Creatinine kinase", 
                "group" : "BLOOD_CHEMISTRY",
                "key" : "bc_cpk" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" :  72 , 
                "label"  : "NH3", 
                "label_1"  : "Ammonia", 
                "group" : "BLOOD_CHEMISTRY",
                "key" : "bc_ammonia" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" :  73 , 
                "label"  : "GLU", 
                "label_1"  : "Glucose", 
                "group" : "BLOOD_CHEMISTRY",
                "key" : "bc_glucose" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" :   74  , 
                "label"  : "UCRE", 
                "label_1"  : "Urine creatinine", 
                "group" : "BLOOD_CHEMISTRY",
                "key" : "ur_creatinine" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" :  75 , 
                "label"  : "UPRO", 
                "label_1"  : "Urine protein", 
                "group" : "BLOOD_CHEMISTRY",
                "key" : "bc_upro" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" :  76 , 
                "label"  : "AMYL", 
                "label_1"  : "Amylase", 
                "group" : "BLOOD_CHEMISTRY",
                "key" : "bc_amylase" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" :  77  , 
                "label"  : "CRP", 
                "label_1"  : "C-reactive protein", 
                "group" : "BLOOD_CHEMISTRY",
                "key" : "bc_crp" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" :  78 , 
                "label"  : "SDMA", 
                "label_1"  : "Symmetric dimethylarginine", 
                "group" : "BLOOD_CHEMISTRY",
                "key" : "bc_sdma" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" :  79  , 
                "label"  : "TT4(T4)", 
                "label_1"  : "Total Thyroxine", 
                "group" : "BLOOD_CHEMISTRY",
                "key" : "bc_tt4" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" :  80 , 
                "label"  : "FRU", 
                "label_1"  : "Fructosamine", 
                "group" : "BLOOD_CHEMISTRY",
                "key" : "sp_fructo" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" :  81 , 
                "label"  : "LAC", 
                "label_1"  : "Lactate", 
                "group" : "BLOOD_CHEMISTRY",
                "key" : "bc_fru" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" :  82  , 
                "label"  : "LDH", 
                "label_1"  : "Lactate dehydrogenase", 
                "group" : "BLOOD_CHEMISTRY",
                "key" : "bc_lac" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" :  83 , 
                "label"  : "LIPA", 
                "label_1"  : "Lipase", 
                "group" : "BLOOD_CHEMISTRY",
                "key" : "sp_lipase" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" :  84  , 
                "label"  : "Mg", 
                "label_1"  : "Magnesium", 
                "group" : "BLOOD_CHEMISTRY",
                "key" : "bc_mg" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" :  85 , 
                "label"  : "PROG", 
                "label_1"  : "Progesterone", 
                "group" : "BLOOD_CHEMISTRY",
                "key" : "bc_prog" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" : 86  , 
                "label"  : "BA", 
                "label_1"  : "Bile acids", 
                "group" : "BLOOD_CHEMISTRY",
                "key" : "bc_bileacid_fasting" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,








            { 
                "id" : 87  , 
                "label"  : "cT4", 
                "label_1"  : "Canine thyroxine", 
                "group" : "HORMONE",
                "key" : "hom_t4" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" :  88 , 
                "label"  : "cTSH", 
                "label_1"  : "Canine thyroid stimulating hormone", 
                "group" : "HORMONE",
                "key" : "hom_ctsh" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" :  89 , 
                "label"  : "cTLI", 
                "label_1"  : "Canine trypsin-like immunoreactivity", 
                "group" : "HORMONE",
                "key" : "hom_ctli" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" :  90 , 
                "label"  : "PHBR", 
                "label_1"  : "Phenobarbitol", 
                "group" : "HORMONE",
                "key" : "sp_phenobarb" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" :  91 , 
                "label"  : "Cortisol", 
                "label_1"  : "Cortisol", 
                "group" : "HORMONE",
                "key" : "hom_cotis" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,






            { 
                "id" :  92 , 
                "label"  : "pH", 
                "label_1"  : "", 
                "group" : "BLOOD_GAS",
                "key" : "bg_ph" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" :  93 , 
                "label"  : "pCO2", 
                "label_1"  : "", 
                "group" : "BLOOD_GAS",
                "key" : "bg_pco2" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true  ,
                "order" : null ,
                "uuid" : ""
            } ,
            { 
                "id" :  94 , 
                "label"  : "pO2", 
                "label_1"  : "", 
                "group" : "BLOOD_GAS",
                "key" : "bg_po2" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" :  95 , 
                "label"  : "Na", 
                "label_1"  : "", 
                "group" : "BLOOD_GAS",
                "key" : "bg_na" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" :  96 , 
                "label"  : "K", 
                "label_1"  : "", 
                "group" : "BLOOD_GAS",
                "key" : "bg_k" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" :  97 , 
                "label"  : "Cl", 
                "label_1"  : "", 
                "group" : "BLOOD_GAS",
                "key" : "bg_ci" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" : 98  , 
                "label"  : "iCa", 
                "label_1"  : "", 
                "group" : "BLOOD_GAS",
                "key" : "bg_ca" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" :  99  , 
                "label"  : "Hb", 
                "label_1"  : "", 
                "group" : "BLOOD_GAS",
                "key" : "bg_hb" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" :  100  , 
                "label"  : "HCT", 
                "label_1"  : "", 
                "group" : "BLOOD_GAS",
                "key" : "bg_hct" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" :  101 , 
                "label"  : "HCO3-act", 
                "label_1"  : "", 
                "group" : "BLOOD_GAS",
                "key" : "bg_hco3" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" : 102  , 
                "label"  : "BE(B)", 
                "label_1"  : "", 
                "group" : "BLOOD_GAS",
                "key" : "bg_be" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" : 103  , 
                "label"  : "ctCO2(P)", 
                "label_1"  : "", 
                "group" : "BLOOD_GAS",
                "key" : "bg_ctco2" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" : 104  , 
                "label"  : "pH(T)", 
                "label_1"  : "", 
                "group" : "BLOOD_GAS",
                "key" : "bg_pht" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" : 105  , 
                "label"  : "pCO2(T)", 
                "label_1"  : "", 
                "group" : "BLOOD_GAS",
                "key" : "bg_pco2t" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" : 106  , 
                "label"  : "pO2(T)", 
                "label_1"  : "", 
                "group" : "BLOOD_GAS",
                "key" : "bg_po2t" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" : 107  , 
                "label"  : "sO2(est)", 
                "label_1"  : "", 
                "group" : "BLOOD_GAS",
                "key" : "bg_so2est" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" :  108   , 
                "label"  : "iCa(7.4)", 
                "label_1"  : "", 
                "group" : "BLOOD_GAS",
                "key" : "bg_ica" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" :  109  , 
                "label"  : "Glc", 
                "label_1"  : "", 
                "group" : "BLOOD_GAS",
                "key" : "bg_glc" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" :  110  , 
                "label"  : "Lac", 
                "label_1"  : "", 
                "group" : "BLOOD_GAS",
                "key" : "bg_lac" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" : 111  , 
                "label"  : "Temperature", 
                "label_1"  : "", 
                "group" : "BLOOD_GAS",
                "key" : "bg_temp" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" : 112  , 
                "label"  : "FIO2", 
                "label_1"  : "", 
                "group" : "BLOOD_GAS",
                "key" : "bg_fio2" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" :  113 , 
                "label"  : "BP", 
                "label_1"  : "", 
                "group" : "BLOOD_GAS",
                "key" : "bg_bp" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" : 114  , 
                "label"  : "HCO3-std", 
                "label_1"  : "", 
                "group" : "BLOOD_GAS",
                "key" : "bg_hco3std" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" : 115  , 
                "label"  : "BE(ecf)", 
                "label_1"  : "", 
                "group" : "BLOOD_GAS",
                "key" : "bg_beecf" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" :  116 , 
                "label"  : "cNa+", 
                "label_1"  : "", 
                "group" : "BLOOD_GAS",
                "key" : "bg_cna" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" :  117  , 
                "label"  : "cK+", 
                "label_1"  : "", 
                "group" : "BLOOD_GAS",
                "key" : "bg_ck" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" :  118   , 
                "label"  : "cCa2+", 
                "label_1"  : "", 
                "group" : "BLOOD_GAS",
                "key" : "bg_cca2" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" : 119  , 
                "label"  : "cCI-", 
                "label_1"  : "", 
                "group" : "BLOOD_GAS",
                "key" : "bg_cci" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" :  120 , 
                "label"  : "cGlc", 
                "label_1"  : "", 
                "group" : "BLOOD_GAS",
                "key" : "bg_cglc" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" : 121  , 
                "label"  : "cLac", 
                "label_1"  : "", 
                "group" : "BLOOD_GAS",
                "key" : "bg_clac" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" : 122  , 
                "label"  : "ctBil", 
                "label_1"  : "", 
                "group" : "BLOOD_GAS",
                "key" : "bg_ctbil" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" : 123  , 
                "label"  : "ctHb", 
                "label_1"  : "", 
                "group" : "BLOOD_GAS",
                "key" : "bg_cthb" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" :  124  , 
                "label"  : "FHHb", 
                "label_1"  : "", 
                "group" : "BLOOD_GAS",
                "key" : "bg_fhhb" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" :  125 , 
                "label"  : "FO2Hb", 
                "label_1"  : "", 
                "group" : "BLOOD_GAS",
                "key" : "bg_fo2hb" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" :   126 , 
                "label"  : "FCOHb", 
                "label_1"  : "", 
                "group" : "BLOOD_GAS",
                "key" : "bg_fcohb" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" : 127  , 
                "label"  : "FMetHb", 
                "label_1"  : "", 
                "group" : "BLOOD_GAS",
                "key" : "bg_fmethb" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" :  128  , 
                "label"  : "sO2", 
                "label_1"  : "", 
                "group" : "BLOOD_GAS",
                "key" : "bg_so2" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" : 129  , 
                "label"  : "AG", 
                "label_1"  : "", 
                "group" : "BLOOD_GAS",
                "key" : "bg_ag" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" : 130  , 
                "label"  : "AG(K)", 
                "label_1"  : "", 
                "group" : "BLOOD_GAS",
                "key" : "bg_agk" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true  ,
                "order" : null  ,
                "uuid" : ""
            } ,
            { 
                "id" :  131  , 
                "label"  : "cHCO3- act", 
                "label_1"  : "", 
                "group" : "BLOOD_GAS",
                "key" : "bg_chact" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" :  132 , 
                "label"  : "cHCO3- std", 
                "label_1"  : "", 
                "group" : "BLOOD_GAS",
                "key" : "bg_chstd" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" :  133 , 
                "label"  : "cBE(ecf)", 
                "label_1"  : "", 
                "group" : "BLOOD_GAS",
                "key" : "bg_cbeecf" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" :  134   , 
                "label"  : "CBE(B)", 
                "label_1"  : "", 
                "group" : "BLOOD_GAS",
                "key" : "BG_CBEB" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true  ,
                "order" : null ,
                "uuid" : ""
            } ,
            { 
                "id" :  135 , 
                "label"  : "cBB", 
                "label_1"  : "", 
                "group" : "BLOOD_GAS",
                "key" : "bg_cbb" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" :  136  , 
                "label"  : "ctCO2(B)", 
                "label_1"  : "", 
                "group" : "BLOOD_GAS",
                "key" : "bg_ctco2b" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            // { 
            //     "id" :  137  , 
            //     "label"  : "Hct", 
            //     "label_1"  : "", 
            //     "group" : "BLOOD_GAS",
            //     "key" : "bg_hct" ,
            //     "isSwitchedCUS1" : false ,
            //     "isSwitchedCUS2" : false ,
            //     "isSwitchedCUS3" : false , 
            //     "isNumberic" :  true  
            // } ,
            { 
                "id" :  137  , 
                "label"  : "BO2", 
                "label_1"  : "", 
                "group" : "BLOOD_GAS",
                "key" : "bg_bo2" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" :  138  , 
                "label"  : "p50", 
                "label_1"  : "", 
                "group" : "BLOOD_GAS",
                "key" : "bg_p50" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" :  139   , 
                "label"  : "p50(T)", 
                "label_1"  : "", 
                "group" : "BLOOD_GAS",
                "key" : "bg_p50t" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" :  140  , 
                "label"  : "p50(st)", 
                "label_1"  : "", 
                "group" : "BLOOD_GAS",
                "key" : "bg_p50st" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" :  141  , 
                "label"  : "pO2/FiO2", 
                "label_1"  : "", 
                "group" : "BLOOD_GAS",
                "key" : "bg_po2fio2" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" :  142  , 
                "label"  : "cCa2+ (7.4)", 
                "label_1"  : "", 
                "group" : "BLOOD_GAS",
                "key" : "bg_cca2p" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" :  143  , 
                "label"  : "pO2(A)", 
                "label_1"  : "", 
                "group" : "BLOOD_GAS",
                "key" : "bg_po2a" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" :  144   , 
                "label"  : "pO2(A)(T)", 
                "label_1"  : "", 
                "group" : "BLOOD_GAS",
                "key" : "bg_po2at" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" :  145  , 
                "label"  : "pO2(A-a)", 
                "label_1"  : "", 
                "group" : "BLOOD_GAS",
                "key" : "bg_po2aa" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" :  146  , 
                "label"  : "pO2(A-a)(T)", 
                "label_1"  : "", 
                "group" : "BLOOD_GAS",
                "key" : "bg_po2aat" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" :  147  , 
                "label"  : "pO2(a/A)", 
                "label_1"  : "", 
                "group" : "BLOOD_GAS",
                "key" : "bg_po2aa1" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" :  148   , 
                "label"  : "pO2(a/A)(T)", 
                "label_1"  : "", 
                "group" : "BLOOD_GAS",
                "key" : "bg_po2aat1" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" :  149  , 
                "label"  : "RI", 
                "label_1"  : "", 
                "group" : "BLOOD_GAS",
                "key" : "bg_ri" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" : 150   , 
                "label"  : "RI(T)", 
                "label_1"  : "", 
                "group" : "BLOOD_GAS",
                "key" : "bg_rit" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" :  151  , 
                "label"  : "ctO2(a)", 
                "label_1"  : "", 
                "group" : "BLOOD_GAS",
                "key" : "bg_cto2a" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" :  152  , 
                "label"  : "ct02(B)", 
                "label_1"  : "", 
                "group" : "BLOOD_GAS",
                "key" : "bg_cto2b" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" :  153  , 
                "label"  : "ctO2(v)", 
                "label_1"  : "", 
                "group" : "BLOOD_GAS",
                "key" : "bg_cto2v" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" :  154   , 
                "label"  : "ctO2(a-v)", 
                "label_1"  : "", 
                "group" : "BLOOD_GAS",
                "key" : "bg_cto2av" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" :  155   , 
                "label"  : "ctO2([a-v]/a)", 
                "label_1"  : "", 
                "group" : "BLOOD_GAS",
                "key" : "bg_cto2ava" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" :  156  , 
                "label"  : "Height", 
                "label_1"  : "", 
                "group" : "BLOOD_GAS",
                "key" : "bg_h" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" :  157  , 
                "label"  : "Weight", 
                "label_1"  : "", 
                "group" : "BLOOD_GAS",
                "key" : "bg_w" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,
            { 
                "id" :  158  , 
                "label"  : "Patient's body temperature", 
                "label_1"  : "", 
                "group" : "BLOOD_GAS",
                "key" : "bg_ptmp" ,
                "isSwitchedCUS1" : false ,
                "isSwitchedCUS2" : false ,
                "isSwitchedCUS3" : false , 
                "isNumberic" :  true   ,
                "order" : null,
                "uuid" : ""
            } ,







     

        ],

        







        // dataLabParamsMaster: [
        //     { "id" : 1 , "label"  : "HGB", "group" : "HEMATOLOGY","key" : "hm_hgb" ,"isSwitchedCUS1" : false ,"isSwitchedCUS2" : false ,"isSwitchedCUS3" : false , "isNumberic" :  true  } ,
        //     { "id" : 2 , "label"  : "PCV", "group" : "HEMATOLOGY", "key" : "hm_pcv","isSwitchedCUS1" : false ,"isSwitchedCUS2" : false ,"isSwitchedCUS3" : false , "isNumberic" :  true } ,
        //     { "id" : 3 , "label"  : "RBC", "group" : "HEMATOLOGY" , "key" : "hm_rbc","isSwitchedCUS1" : false   ,"isSwitchedCUS2" : false ,"isSwitchedCUS3" : false  , "isNumberic" :  true} ,
        //     { "id" : 4 , "label"  : "WBC", "group" : "HEMATOLOGY", "key" : "hm_wbc"  ,"isSwitchedCUS1" : false ,"isSwitchedCUS2" : false ,"isSwitchedCUS3" : false , "isNumberic" :  true } ,
        //     { "id" : 5 , "label"  : "My cyte", "group" : "HEMATOLOGY", "key" : "hm_my_cyte"  ,"isSwitchedCUS1" : false ,"isSwitchedCUS2" : false ,"isSwitchedCUS3" : false , "isNumberic" :  true } ,
        //     { "id" : 6 , "label"  : "META", "group" : "HEMATOLOGY","key" : "hm_meta" ,"isSwitchedCUS1" : false ,"isSwitchedCUS2" : false ,"isSwitchedCUS3" : false  , "isNumberic" :  true } ,
        //     { "id" : 7 , "label"  : "BAND", "group" : "HEMATOLOGY", "key" : "hm_band","isSwitchedCUS1" : false ,"isSwitchedCUS2" : false ,"isSwitchedCUS3" : false  , "isNumberic" :  true} ,
        //     { "id" : 8 , "label"  : "SEGS", "group" : "HEMATOLOGY" , "key" : "hm_segs","isSwitchedCUS1" : false    ,"isSwitchedCUS2" : false ,"isSwitchedCUS3" : false  , "isNumberic" :  true} ,
        //     { "id" : 9 , "label"  : "LYMPH", "group" : "HEMATOLOGY", "key" : "hm_lymph"  ,"isSwitchedCUS1" : false ,"isSwitchedCUS2" : false ,"isSwitchedCUS3" : false  , "isNumberic" :  true } ,
        //     { "id" : 11 , "label"  : "MONO", "group" : "HEMATOLOGY","key" : "hm_mono" ,"isSwitchedCUS1" : false  ,"isSwitchedCUS2" : false ,"isSwitchedCUS3" : false  , "isNumberic" :  true } ,
        //     { "id" : 12 , "label"  : "EOS", "group" : "HEMATOLOGY", "key" : "hm_eos","isSwitchedCUS1" : false,"isSwitchedCUS2" : false ,"isSwitchedCUS3" : false   , "isNumberic" :  true } ,
        //     { "id" : 13 , "label"  : "UNCLASS", "group" : "HEMATOLOGY" , "key" : "hm_unclass","isSwitchedCUS1" : false  ,"isSwitchedCUS2" : false ,"isSwitchedCUS3" : false  , "isNumberic" :  true } ,
        //     { "id" : 14 , "label"  : "NUCL RBC", "group" : "HEMATOLOGY", "key" : "hm_nucl_rbc"  ,"isSwitchedCUS1" : false ,"isSwitchedCUS2" : false ,"isSwitchedCUS3" : false  , "isNumberic" :  true } ,
        //     { "id" : 15 , "label"  : "RETICS", "group" : "HEMATOLOGY", "key" : "hm_retics"  ,"isSwitchedCUS1" : false ,"isSwitchedCUS2" : false ,"isSwitchedCUS3" : false  , "isNumberic" :  true } ,
        //     { "id" : 16 , "label"  : "PLATELETS", "group" : "HEMATOLOGY","key" : "hm_platelets" ,"isSwitchedCUS1" : false ,"isSwitchedCUS2" : false ,"isSwitchedCUS3" : false   , "isNumberic" :  true} ,
        //     { "id" : 17 , "label"  : "PROTEIN REFRACT", "group" : "HEMATOLOGY", "key" : "hm_protein_refract","isSwitchedCUS1" : false  ,"isSwitchedCUS2" : false ,"isSwitchedCUS3" : false  , "isNumberic" :  true} ,
        //     { "id" : 18 , "label"  : "RDW", "group" : "HEMATOLOGY" , "key" : "hm_rdw","isSwitchedCUS1" : false  ,"isSwitchedCUS2" : false ,"isSwitchedCUS3" : false  , "isNumberic" :  true } ,
        //     { "id" : 19 , "label"  : "MPV", "group" : "HEMATOLOGY", "key" : "hm_mpv"  ,"isSwitchedCUS1" : false ,"isSwitchedCUS2" : false ,"isSwitchedCUS3" : false  , "isNumberic" :  true} ,
        //     { "id" : 20 , "label"  : "APLT", "group" : "HEMATOLOGY", "key" : "hm_aplt"  ,"isSwitchedCUS1" : false ,"isSwitchedCUS2" : false ,"isSwitchedCUS3" : false   , "isNumberic" :  true} ,
        //     { "id" : 21 , "label"  : "BUN", "group" : "BLOOD CHEMISTRY","key" : "bc_bun" ,"isSwitchedCUS1" : false  ,"isSwitchedCUS2" : false ,"isSwitchedCUS3" : false  , "isNumberic" :  true } ,
        //     { "id" : 22 , "label"  : "CREATININE", "group" : "BLOOD CHEMISTRY", "key" : "bc_creatinine","isSwitchedCUS1" : false,"isSwitchedCUS2" : false ,"isSwitchedCUS3" : false  , "isNumberic" :  true } ,
        //     { "id" : 23 , "label"  : "GLUCOSE", "group" : "BLOOD CHEMISTRY" , "key" : "bc_glucose","isSwitchedCUS1" : false,"isSwitchedCUS2" : false ,"isSwitchedCUS3" : false   , "isNumberic" :  true  } ,
        //     { "id" : 24 , "label"  : "AMYLASE", "group" : "BLOOD CHEMISTRY", "key" : "bc_amylase"  ,"isSwitchedCUS1" : false  ,"isSwitchedCUS2" : false ,"isSwitchedCUS3" : false  , "isNumberic" :  true} ,
        //     { "id" : 25 , "label"  : "ALT SGPT", "group" : "BLOOD CHEMISTRY", "key" : "bc_alt_sgpt"  ,"isSwitchedCUS1" : false ,"isSwitchedCUS2" : false ,"isSwitchedCUS3" : false , "isNumberic" :  true } ,
        //     { "id" : 26 , "label"  : "AST SGOT", "group" : "BLOOD CHEMISTRY","key" : "bc_ast_sgot" ,"isSwitchedCUS1" : false ,"isSwitchedCUS2" : false ,"isSwitchedCUS3" : false  , "isNumberic" :  true } ,
        //     { "id" : 27 , "label"  : "ALK PHOS", "group" : "BLOOD CHEMISTRY", "key" : "bc_alk_phos","isSwitchedCUS1" : false ,"isSwitchedCUS2" : false ,"isSwitchedCUS3" : false  , "isNumberic" :  true } ,
        //     { "id" : 28 , "label"  : "CPK", "group" : "BLOOD CHEMISTRY" , "key" : "bc_cpk","isSwitchedCUS1" : false  ,"isSwitchedCUS2" : false ,"isSwitchedCUS3" : false  , "isNumberic" :  true  } ,
        //     { "id" : 29 , "label"  : "BILEACID FASTING", "group" : "BLOOD CHEMISTRY", "key" : "bc_bileacid_fasting"  ,"isSwitchedCUS1" : false ,"isSwitchedCUS2" : false ,"isSwitchedCUS3" : false  , "isNumberic" :  true } ,
        //     { "id" : 30 , "label"  : "POSTPRANDIAL", "group" : "BLOOD CHEMISTRY", "key" : "bc_postprandial"  ,"isSwitchedCUS1" : false ,"isSwitchedCUS2" : false ,"isSwitchedCUS3" : false  , "isNumberic" :  true} ,
        //     { "id" : 31 , "label"  : "BILIRUBIN TOTAL", "group" : "BLOOD CHEMISTRY","key" : "bc_bilirubin_total" ,"isSwitchedCUS1" : false ,"isSwitchedCUS2" : false ,"isSwitchedCUS3" : false  , "isNumberic" :  true } ,
        //     { "id" : 32 , "label"  : "DIRECT", "group" : "BLOOD CHEMISTRY", "key" : "bc_direct","isSwitchedCUS1" : false ,"isSwitchedCUS2" : false ,"isSwitchedCUS3" : false , "isNumberic" :  true } ,
        //     { "id" : 33 , "label"  : "CHOLESTEROL", "group" : "BLOOD CHEMISTRY" , "key" : "bc_cholesterol","isSwitchedCUS1" : false ,"isSwitchedCUS2" : false ,"isSwitchedCUS3" : false   , "isNumberic" :  true } ,
        //     { "id" : 34 , "label"  : "TRIGLYCERIDE", "group" : "BLOOD CHEMISTRY", "key" : "bc_triglyceride"  ,"isSwitchedCUS1" : false ,"isSwitchedCUS2" : false ,"isSwitchedCUS3" : false  , "isNumberic" :  true} ,
        //     { "id" : 35 , "label"  : "FIBRINOGEN", "group" : "BLOOD CHEMISTRY", "key" : "bc_fibrinogen"  ,"isSwitchedCUS1" : false ,"isSwitchedCUS2" : false ,"isSwitchedCUS3" : false  , "isNumberic" :  true} ,
        //     { "id" : 36 , "label"  : "PROTEIN BIURET", "group" : "BLOOD CHEMISTRY", "key" : "bc_protein_biuret"  ,"isSwitchedCUS1" : false ,"isSwitchedCUS2" : false ,"isSwitchedCUS3" : false  , "isNumberic" :  true} ,
        //     { "id" : 37 , "label"  : "ALBUMIN", "group" : "BLOOD CHEMISTRY", "key" : "bc_albumin"  ,"isSwitchedCUS1" : false ,"isSwitchedCUS2" : false ,"isSwitchedCUS3" : false  , "isNumberic" :  true } ,
        //     { "id" : 38 , "label"  : "CALCIUM", "group" : "BLOOD CHEMISTRY", "key" : "bc_calcium"  ,"isSwitchedCUS1" : false ,"isSwitchedCUS2" : false ,"isSwitchedCUS3" : false  , "isNumberic" :  true} ,
        //     { "id" : 39 , "label"  : "PHOSPHORUS", "group" : "BLOOD CHEMISTRY", "key" : "bc_phosphorus"  ,"isSwitchedCUS1" : false ,"isSwitchedCUS2" : false ,"isSwitchedCUS3" : false  , "isNumberic" :  true} ,
        //     { "id" : 40 , "label"  : "SODIUM", "group" : "BLOOD CHEMISTRY", "key" : "bc_sodium"  ,"isSwitchedCUS1" : false ,"isSwitchedCUS2" : false ,"isSwitchedCUS3" : false  , "isNumberic" :  true} ,
        //     { "id" : 41 , "label"  : "POTASSIUM", "group" : "BLOOD CHEMISTRY", "key" : "bc_potassium"  ,"isSwitchedCUS1" : false  ,"isSwitchedCUS2" : false ,"isSwitchedCUS3" : false  , "isNumberic" :  true} ,
        //     { "id" : 42 , "label"  : "CHLORIDE", "group" : "BLOOD CHEMISTRY", "key" : "bc_chloride"  ,"isSwitchedCUS1" : false ,"isSwitchedCUS2" : false ,"isSwitchedCUS3" : false  , "isNumberic" :  true} ,
        //     { "id" : 43 , "label"  : "AMMONIA", "group" : "BLOOD CHEMISTRY", "key" : "bc_ammonia"  ,"isSwitchedCUS1" : false ,"isSwitchedCUS2" : false ,"isSwitchedCUS3" : false  , "isNumberic" :  true} ,
        //     { "id" : 44 , "label"  : "BABESIA", "group" : "BLOOD PARASITE", "key" : "bp_babesia_sp"  ,"isSwitchedCUS1" : false ,"isSwitchedCUS2" : false  ,"isSwitchedCUS3" : false  , "isNumberic" :  false} ,
        //     { "id" : 46 , "label"  : "HEPATOZOON CANIS", "group" : "BLOOD PARASITE", "key" : "bp_hepatozoon_canis"  ,"isSwitchedCUS1" : false ,"isSwitchedCUS2" : false ,"isSwitchedCUS3" : false , "isNumberic" :  false } ,
        //     { "id" : 47 , "label"  : "MICROFILARIA", "group" : "BLOOD PARASITE", "key" : "bp_microfilaria"  ,"isSwitchedCUS1" : false ,"isSwitchedCUS2" : false ,"isSwitchedCUS3" : false , "isNumberic" :  false } ,
        //     { "id" : 48 , "label"  : "EHRLICHIA PLATYS", "group" : "BLOOD PARASITE", "key" : "bp_ehrlichia_platys"  ,"isSwitchedCUS1" : false,"isSwitchedCUS2" : false ,"isSwitchedCUS3" : false , "isNumberic" :  false  } ,
        //     { "id" : 49 , "label"  : "HAEMOBARTONELLA FELIS", "group" : "BLOOD PARASITE", "key" : "bp_haemobartonella_felis"  ,"isSwitchedCUS1" : false  ,"isSwitchedCUS2" : false ,"isSwitchedCUS3" : false  , "isNumberic" :  false} ,
        //     { "id" : 50 , "label"  : "SP GR", "group" : "UA", "key" : "ur_sp_gr"  ,"isSwitchedCUS1" : false  ,"isSwitchedCUS2" : false ,"isSwitchedCUS3" : false  , "isNumberic" :  true} ,
        //     { "id" : 51 , "label"  : "PH", "group" : "UA", "key" : "ur_ph"  ,"isSwitchedCUS1" : false ,"isSwitchedCUS2" : false ,"isSwitchedCUS3" : false , "isNumberic" :  true } ,
        //     { "id" : 52 , "label"  : "PROTEIN", "group" : "UA", "key" : "ur_protein_amount"  ,"isSwitchedCUS1" : false ,"isSwitchedCUS2" : false ,"isSwitchedCUS3" : false , "isNumberic" :  true } ,

        //     { "id" : 53 , "label"  : "T4", "group" : "HORMONE", "key" : "hom_t4"  ,"isSwitchedCUS1" : false ,"isSwitchedCUS2" : false ,"isSwitchedCUS3" : false , "isNumberic" :  true } ,
        //     { "id" : 54 , "label"  : "Free T4", "group" : "HORMONE", "key" : "hor_freet4"  ,"isSwitchedCUS1" : false ,"isSwitchedCUS2" : false ,"isSwitchedCUS3" : false , "isNumberic" :  true } ,
        //     { "id" : 55 , "label"  : "Canine T4", "group" : "HORMONE", "key" : "hor_cat4"  ,"isSwitchedCUS1" : false ,"isSwitchedCUS2" : false ,"isSwitchedCUS3" : false , "isNumberic" :  true } ,
        //     { "id" : 56 , "label"  : "TSH", "group" : "HORMONE", "key" : "hor_catsh"  ,"isSwitchedCUS1" : false ,"isSwitchedCUS2" : false ,"isSwitchedCUS3" : false , "isNumberic" :  true } ,
        //     { "id" : 57 , "label"  : "Cortisol", "group" : "HORMONE", "key" : "hor_cartisol"  ,"isSwitchedCUS1" : false ,"isSwitchedCUS2" : false ,"isSwitchedCUS3" : false , "isNumberic" :  true } ,
        //     { "id" : 58 , "label"  : "Estrogen", "group" : "HORMONE", "key" : "hor_estra"  ,"isSwitchedCUS1" : false ,"isSwitchedCUS2" : false ,"isSwitchedCUS3" : false , "isNumberic" :  true } ,
        //     { "id" : 59 , "label"  : "Progesterone", "group" : "HORMONE", "key" : "hor_pro"  ,"isSwitchedCUS1" : false ,"isSwitchedCUS2" : false ,"isSwitchedCUS3" : false , "isNumberic" :  true } ,
        //     { "id" : 60 , "label"  : "Testosterone", "group" : "HORMONE", "key" : "hor_tes"  ,"isSwitchedCUS1" : false ,"isSwitchedCUS2" : false ,"isSwitchedCUS3" : false , "isNumberic" :  true } ,
        //     { "id" : 61 , "label"  : "TLI", "group" : "HORMONE", "key" : "hor_catli"  ,"isSwitchedCUS1" : false ,"isSwitchedCUS2" : false ,"isSwitchedCUS3" : false , "isNumberic" :  true } ,
        //     { "id" : 62 , "label"  : "Insulin", "group" : "HORMONE", "key" : "hor_insulin"  ,"isSwitchedCUS1" : false ,"isSwitchedCUS2" : false ,"isSwitchedCUS3" : false , "isNumberic" :  true } ,
        //     { "id" : 62 , "label"  : "Parathyroid (PTH)", "group" : "HORMONE", "key" : "hor_pth"  ,"isSwitchedCUS1" : false ,"isSwitchedCUS2" : false ,"isSwitchedCUS3" : false , "isNumberic" :  true } ,
        //     { "id" : 63 , "label"  : "FSH", "group" : "HORMONE", "key" : "hor_fsh"  ,"isSwitchedCUS1" : false ,"isSwitchedCUS2" : false ,"isSwitchedCUS3" : false , "isNumberic" :  true } ,
        //     { "id" : 64 , "label"  : "LH", "group" : "HORMONE", "key" : "hor_lh"  ,"isSwitchedCUS1" : false ,"isSwitchedCUS2" : false ,"isSwitchedCUS3" : false , "isNumberic" :  true } ,
        //     { "id" : 65 , "label"  : "ACTH", "group" : "HORMONE", "key" : "hor_acth"  ,"isSwitchedCUS1" : false ,"isSwitchedCUS2" : false ,"isSwitchedCUS3" : false , "isNumberic" :  true } ,
        //     { "id" : 66 , "label"  : "URIN COSTISOL", "group" : "HORMONE", "key" : "hor_urin_costisol"  ,"isSwitchedCUS1" : false ,"isSwitchedCUS2" : false ,"isSwitchedCUS3" : false , "isNumberic" :  true } ,


        // ],




        dataLabParamsMasterUA: [
            { "id" : 1 , "label"  : "COLLECTION TECHNIC" ,"key" : "ur_collection_technic_values"    } ,
            { "id" : 2 , "label"  : "COLOR" , "key" : "ur_color" } ,
            { "id" : 3 , "label"  : "TRANSPARENCY"  , "key" : "ur_transparency"} ,
            { "id" : 4 , "label"  : "RBC" , "key" : "ur_rbc"} ,
            { "id" : 5 , "label"  : "WBC" , "key" : "ur_wbc" } ,
            { "id" : 6 , "label"  : "PH" ,"key" : "ur_ph"} ,
            { "id" : 7 , "label"  : "URINE CREATININE" , "key" : "ur_creatinine"} ,
            { "id" : 8 , "label"  : "SP. GR."  , "key" : "ur_sp_gr"} ,
            { "id" : 9 , "label"  : "URINE PROTEIN" ,"key" : "ur_protein_amount"} ,
            { "id" : 10  , "label"  : "UPCR" , "key" : "upcr"} ,
            { "id" : 11 , "label"  : "NIRITE"  , "key" : "ur_nirite"} ,
            { "id" : 12 , "label"  : "UROBILINOGEN" ,"key" : "ur_urobilinogen"} ,
            { "id" : 13  , "label"  : "PROTEIN" , "key" : "ur_protein"} ,
            { "id" : 14 , "label"  : "BLOOD" ,"key" : "ur_blood"} ,
            { "id" : 15 , "label"  : "KETONE" , "key" : "ur_ketone"} ,
            { "id" : 16 , "label"  : "BILIRUBIN"  , "key" : "ur_bilirubin"} ,
            { "id" : 17  , "label"  : "GLUCOSE" ,"key" : "ur_glucose"} ,
            { "id" : 18 , "label"  : "LEU" , "key" : "ur_leu"} ,
            { "id" : 19 , "label"  : "BACT."  , "key" : "ur_bact"} ,
            { "id" : 20 , "label"  : "SPREM." ,"key" : "ur_sprem"} ,
            { "id" : 21 , "label"  : "FAT. DRP." , "key" : "ur_fat_drp"} ,
            { "id" : 22 , "label"  : "CAST"  , "key" : "ur_casts"} ,
            { "id" : 23 , "label"  : "FATTY CAST" ,"key" : "ur_casts_fatty"} ,
            { "id" : 24 , "label"  : "HYALINE CAST" , "key" : "ur_casts_hyaline"} ,
            { "id" : 25 , "label"  : "FINE GRANULAR"  , "key" : "ur_casts_fine_granular"} ,
            { "id" : 26 , "label"  : "COARSE GRANULAR" ,"key" : "ur_casts_coarse_granular"} ,
            { "id" : 27 , "label"  : "WAXY" , "key" : "ur_casts_waxy"} ,
            { "id" : 28 , "label"  : "BROAD CAST"  , "key" : "ur_casts_broad"} ,
            { "id" : 29 , "label"  : "CELLULAR CAST" ,"key" : "ur_casts_cellular"} ,
            { "id" : 30 , "label"  : "CYSTALS" , "key" : "ur_cystals"} ,
            { "id" : 31 , "label"  : "AMMONIUM URATE"  , "key" : "ur_cystal_ammonium_urate"} ,
            { "id" : 32 , "label"  : "SODIUM URATE"  , "key" : "ur_cystal_sodium_urate"} ,
            { "id" : 33 , "label"  : "AMORPHOUS URATE"  , "key" : "ur_cystal_amorphous_urate"} ,
            { "id" : 34 , "label"  : "CALCIUM CARBONATE"  , "key" : "ur_cystal_calcium_carbonate"} ,
            { "id" : 35 , "label"  : "CALCIUM OX. MONO."  , "key" : "ur_cystal_calcium_ox_mono"} ,
            { "id" : 36 , "label"  : "CALCIUM OX. DIHY."  , "key" : "ur_cystal_calcium_ox_dihy"} ,
            { "id" : 37 , "label"  : "AMORPHOUS PHOSPHAT"  , "key" : "ur_cystal_amorphous_phosphat"} ,
            { "id" : 38, "label"  : "MAG. AMMONIUM. PHOS. "  , "key" : "ur_cystal_mag_ammonium_phos"} ,
            { "id" : 39 , "label"  : "BITIRUBIN"  , "key" : "ur_cystal_bitirubin"} ,
            { "id" : 40 , "label"  : "CHOLESTEROL"  , "key" : "ur_cystal_cholesterol"} ,
            { "id" : 41 , "label"  : "CYSTINE"  , "key" : "ur_cystal_cystine"} ,
            { "id" : 42 , "label"  : "HIPPURIC ACID"  , "key" : "ur_cystal_hippuric_acid"} ,
            { "id" : 43 , "label"  : "LEUCINE"  , "key" : "ur_cystal_leucine"} ,
            { "id" : 44 , "label"  : "CALCIUM PHOS."  , "key" : "ur_cystal_calcium_phos"} ,
            { "id" : 45 , "label"  : "SODIUM SULFATE"  , "key" : "ur_cystal_sodium_sulfate"} ,
            { "id" : 46 , "label"  : "URIC ACID"  , "key" : "ur_cystal_uric_acid"} ,
            { "id" : 47 , "label"  : "SULFONAMIDE"  , "key" : "ur_cystal_sulfonamide"} ,
            { "id" : 48 , "label"  : "TYROSINE"  , "key" : "ur_cystal_tyrosine"} ,
            { "id" : 49 , "label"  : "EPITH"  , "key" : "ur_epith"} ,
            { "id" : 50 , "label"  : "RENAL TURBULAR"  , "key" : "ur_epith_renal_turbular"} ,
            { "id" : 51 , "label"  : "SQUAMOUS"  , "key" : "ur_epith_squamous"} ,
            { "id" : 52 , "label"  : "TRANSITIAONAL"  , "key" : "ur_epith_transitiaonal"} ,
            { "id" : 53 , "label"  : "CAUDAL"  , "key" : "ur_epith_caudal"} ,
            ],
        province:[],
        ampur:[],
        tumbon:[],
        labStaff : [],
        listofdisablereason :[] ,
        access_token : null

    },

    getters: {
        getStatusLabs: state => {
            return state.statusLabs.map(dat=>{
                return dat
            })
            }
    },

    mutations: {

           
        setUser_full_name_surname(state, user_full_name_surname) {
            state.user_full_name_surname = user_full_name_surname
        },



        setDataLabParamsMaster(state, dataLabParamsMaster) {
            state.dataLabParamsMaster = dataLabParamsMaster
        },
        setDataLabParamsMaster_1(state, dataLabParamsMaster_1) {
            state.dataLabParamsMaster_1 = dataLabParamsMaster_1
        },
        setDataLabParamsMaster_2(state, dataLabParamsMaster_2) {
            state.dataLabParamsMaster_2 = dataLabParamsMaster_2
        },



        setAccess_token (state, access_token) {
            state.access_token = access_token
        },
        setListofdisablereason (state, listofdisablereason) {
            state.listofdisablereason = listofdisablereason
        },
        setLabStaff (state, labStaff) {
            state.labStaff = labStaff
        },
        setCounterTest(state,counterTest){
            state.counterTest = counterTest
        },
        setUserRole(state,user_role){
            state.user_role = user_role
        },
        setClientIP(state,clientIP){
            state.clientIP = clientIP
        },
        setAvartar(state,avartar){
            state.avartar = avartar
        },
        setFingerPrint (state, fingerPrint) {
            /* eslint-disable no-console */
            state.fingerPrint = fingerPrint
        },
        setPathologists (state, pathologists) {
            state.pathologists = pathologists
        },
        setParasitologist (state, parasitologists) {
            state.parasitologists = parasitologists
        },
         
        setDocKind (state, docKind) {
            state.docKind = docKind
        },
        setDocKindAll (state, docKindAll) {
            state.docKindAll = docKindAll
        },
        setStatusLabs (state, statusLabs) {
            state.statusLabs = statusLabs
        },

        setUserId (state, user_id) {
            state.user_id = user_id
        },


        setUserName (state, userName) {
            state.userName = userName
        },



        setUserIsAdmin (state,userIsadmin){
            state.userIsAdmin = userIsadmin
        },
        setUnitCBC (state, unitCBC) {
            state.unitCBC = unitCBC
        },
        setUserCustomizeCBCTbl (state, userCustomizeCBCTbl) {
            state.userCustomizeCBCTbl.cus1 = userCustomizeCBCTbl.cus1
            state.userCustomizeCBCTbl.cus2 = userCustomizeCBCTbl.cus2
            state.userCustomizeCBCTbl.cus3 = userCustomizeCBCTbl.cus3
        },
        produceUserCustomizeCBCTblByCus(state,payload){
            if(payload.cus_no === 'CUS1'){
                state.userCustomizeCBCTbl.cus1 =payload.data
            }else if(payload.cus_no === 'CUS2'){
                state.userCustomizeCBCTbl.cus2 =payload.data
            }else if(payload.cus_no === 'CUS3'){
                state.userCustomizeCBCTbl.cus3 =payload.data
            }
        },
        setProvince (state, province) {
            state.province = province
        },
        setAmpur (state, ampur) {
            state.ampur = ampur
        },
        setTumbon (state, tumbon) {
            state.tumbon = tumbon
        },
    },

    actions: {
    produceAccessToken({commit},access_token){
        commit('setAccess_token', access_token)
    },
    produceSetCounterTest({commit},counterTest){
        commit('setCounterTest',counterTest)
    },
    produceUserRole({commit},user_role){
        commit('setUserRole', user_role)
    },
    fetchClientIP({commit}){
            return new Promise((resolve) => {
                axios.get('https://api.ipify.org?format=json')
                    .then((res)=>{
                        // console.log(res.data.ip)
                        commit('setClientIP', res.data.ip)
                    })
                    .catch(()=>{
                        commit('setClientIP', '0.0.0.0')
                    })
                resolve()
            })

       },
       produceUserAvartar({commit},url){
            commit('setAvartar', url)
        },

     fetchFingerprint({commit}){
       return new Promise( (resolve)=> {
           if (window.requestIdleCallback) {
               requestIdleCallback(function () {
                   Fingerprint2.get(function (components) {
                       var values = components.map(function (component) {
                           return component.value
                       })
                       const fingerprint = Fingerprint2.x64hash128(values.join(''), 31)
                       commit('setFingerPrint', fingerprint)
                       resolve(fingerprint)
                   })
               })
           } else {
               setTimeout(function () {
                   Fingerprint2.get(function (components) {
                       var values = components.map(function (component) {
                           return component.value
                       })
                       const fingerprint = Fingerprint2.x64hash128(values.join(''), 31)

                       commit('setFingerPrint', fingerprint)
                       resolve(fingerprint)
                   })
               }, 500)

           }
         }
       )
        },


        produceUserCustomizeCBCTblByCus({commit},payload){
            commit('produceUserCustomizeCBCTblByCus', payload)
        },




        fetchUserCustomizeCBCTbl({commit,state}, user_id) {

            return new Promise((resolve) => {
                axios.defaults.headers.common['Authorization'] = `Bearer ${state.access_token}` 
                axios.get(`${getBaseURLforBackEnd()}/api/cuscbc/${user_id}`,getConfigAxios())
                    .then((res)=>{
                        // console.log( res.data.cus1)
                        // console.log( res.data.cus2)
                        // console.log( res.data.cus3) 
                         if(res.data.cus1!==''){
                            commit('setDataLabParamsMaster', res.data.cus1)
                         }
                         if(res.data.cus2!==''){
                            commit('setDataLabParamsMaster_1', res.data.cus2)
                         }
                         if(res.data.cus3!==''){
                            commit('setDataLabParamsMaster_2', res.data.cus3)
                         }
                      //  commit('setUserCustomizeCBCTbl', res.data)
                    })
                resolve()
            })


        } ,

        fetchUnitCBC({commit}) {

            return new Promise((resolve) => {
                axios.get(`${getBaseURLforBackEnd()}/api/labcbc_units`,getConfigAxios())
                    .then((res)=>{

                        commit('setUnitCBC', res.data)
                    })
                resolve()
            })
        } ,

      //****************************************************************************************************************

        fetchLabStaff({commit}) {

            return new Promise((resolve) => {
                // make the call
                // call setProducts mutation
                //    api_master_data.getPathologists(pathologists => {
                //     commit('setPathologists', pathologists)
                //     resolve()
                // })

                axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem("access_token")}`
                axios.post(`${getBaseURLforBackEnd()}/api/getlistoflabstaff`,getConfigAxios())
                    .then((res)=>{
                        commit('setLabStaff', res.data)
                        resolve()
                    })

            })
        } ,


      //****************************************************************************************************************
        fetchPathologists({commit}) {

            return new Promise((resolve) => {
                // make the call
                // call setProducts mutation
                //    api_master_data.getPathologists(pathologists => {
                //     commit('setPathologists', pathologists)
                //     resolve()
                // })


                axios.get(`${getBaseURLforBackEnd()}/api/pathologists`,getConfigAxios())
                    .then((res_pathologists)=>{
                        commit('setPathologists', res_pathologists.data)
                    })
                resolve()
             })
        } ,

        //****************************************************************************************************************
        fetchParasitologist({commit}) {
            return new Promise((resolve) => {
                axios.post(`${getBaseURLforBackEnd()}/api/getlistofparasitologist`,getConfigAxios())
                    .then((res_Parasitologist)=>{
                        // console.log(res_Parasitologist)
                        commit('setParasitologist', res_Parasitologist.data)
                    })
                resolve()
             })
        } ,




        fetchDocKindAll({commit}) {

            return new Promise((resolve) => {
                axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem("access_token")}`
                axios.post(`${getBaseURLforBackEnd()}/api/dockind_all`,getConfigAxios())
                    .then((res)=>{
                        // console.log('fetchDocKind')
                        // console.log(res.data)
                        commit('setDocKindAll', res.data)
                        resolve()
                    })

            })
        } ,


        //**************************************************************************************************************
        fetchDocKind({commit}) {

            return new Promise((resolve) => {
                // make the call
                // call setProducts mutation
                //    api_master_data.getPathologists(pathologists => {
                //     commit('setPathologists', pathologists)
                //     resolve()
                // })

                const dat ={
                    "automate" : false
                   }

                axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem("access_token")}`
                axios.post(`${getBaseURLforBackEnd()}/api/dockind`,dat,getConfigAxios())
                    .then((res)=>{
                        // console.log('fetchDocKind')
                        // console.log(res.data)
                        commit('setDocKind', res.data)
                        resolve()
                    })

            })
        } ,



        //**************************************************************************************************************

        fetchStatusLabs({commit}) {

            return new Promise((resolve) => {
                // make the call
                // call setProducts mutation
                // api_master_data.getStatusLabs(statusLabs => {
                //     commit('setStatusLabs', statusLabs)
                //     resolve()
                // })

                axios.post(`${getBaseURLforBackEnd()}/api/master_statuslabs`,getConfigAxios())
                    .then((res)=>{
                        commit('setStatusLabs', res.data)
                    })
                resolve()

            })
        },

        // fakeUserID({commit}){
        //     commit('setUserId', 2)
        // },


        produceUserID({commit},user_id){
            commit('setUserId', user_id)
        },


        produceUserName({commit},userName){
            commit('setUserName', userName)
        },



        produceUserIsAdmin({commit},userIsAdmin){
            commit('setUserIsAdmin',userIsAdmin)
        },

        fetchProvince({commit,state}) {

            return new Promise((resolve) => {
                axios.defaults.headers.common['Authorization'] = `Bearer ${state.access_token}`
                axios.post(`${getBaseURLforBackEnd()}/api/provincelist`,getConfigAxios())
                    .then((res)=>{
                        commit('setProvince', res.data)
                    })
                resolve()
            })
        } ,


        fetchAmpur({commit,state}) {

            return new Promise((resolve) => {
                axios.defaults.headers.common['Authorization'] = `Bearer ${state.access_token}`
                axios.post(`${getBaseURLforBackEnd()}/api/ampurlist`,getConfigAxios())
                    .then((res)=>{
                        commit('setAmpur', res.data)
                    })
                resolve()
            })
        } ,



        fetchTumbon({commit,state}) {

            return new Promise((resolve) => {
                axios.defaults.headers.common['Authorization'] = `Bearer ${state.access_token}`
                axios.post(`${getBaseURLforBackEnd()}/api/tumbonlist`,getConfigAxios())
                    .then((res)=>{
                        commit('setTumbon', res.data)
                    })
                resolve()
            })
        } ,



        // *************************************************************************************************************
        fetchListOfDisableReason({commit}) {

            return new Promise((resolve) => {
                axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem("access_token")}`
                axios.post(`${getBaseURLforBackEnd()}/api/listofdisablereason`, {"admin": false}, getConfigAxios())
                    .then((res) => {
                        commit('setListofdisablereason', res.data)
                        resolve()
                    })

            })
        } ,


    }
}